
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bxwDC", function(module, exports) {
$parcel$export(module.exports, "LoggedOutOrNoJiraProductTourOverview", function () { return (parcelRequire("gHXqX")).LoggedOutOrNoJiraProductTourOverview; });

var $gHXqX = parcelRequire("gHXqX");

});
parcelRegister("gHXqX", function(module, exports) {
$parcel$export(module.exports, "LoggedOutOrNoJiraProductTourOverview", function () { return $9c557963d1338261$export$94dc3fb7b045f547; });
/* jira-software-logged-out-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bQjAr = parcelRequire("bQjAr");

var $doAVE = parcelRequire("doAVE");

var $kbpa7 = parcelRequire("kbpa7");

var $l4vdU = parcelRequire("l4vdU");

var $ea4mV = parcelRequire("ea4mV");

var $j6FQw = parcelRequire("j6FQw");

var $8IN8s = parcelRequire("8IN8s");

var $iKNCS = parcelRequire("iKNCS");

var $Tm4Gw = parcelRequire("Tm4Gw");

var $73ThH = parcelRequire("73ThH");
parcelRequire("7J8Er");
var $4AJjX = parcelRequire("4AJjX");
var $ihq7I = parcelRequire("ihq7I");
var $fCRLS = parcelRequire("fCRLS");
var $bRgjW = parcelRequire("bRgjW");
var $dS67T = parcelRequire("dS67T");
var $1i0Tw = parcelRequire("1i0Tw");
var $6PlQY = parcelRequire("6PlQY");

var $iFk4q = parcelRequire("iFk4q");

var $1UnBI = parcelRequire("1UnBI");
const $9c557963d1338261$export$94dc3fb7b045f547 = ()=>{
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    const [jiraFflExposureFired, fireJiraFflExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4666JiraFfl);
    (0, $1oC0p.useEffect)(()=>{
        if (!jiraFflExposureFired) fireJiraFflExposure();
    }, [
        jiraFflExposureFired,
        fireJiraFflExposure
    ]);
    let heroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1i0Tw.NoJiraHeroSection), {});
    if (isLoggedOut) heroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1UnBI.LoggedOutHeroSection), {});
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "logged-out-no-jira-product-tour",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Tm4Gw.JiraSoftwarePageBannerAlert), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4vdU.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                "data-testid": "loggedOutNoJira",
                id: "content",
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $j6FQw.ParentScrollTracking), {
                    scrollTrackingEnabled: true,
                    pageId: "Jira",
                    children: [
                        heroSection,
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $73ThH.GartnerSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bRgjW.JswCollaborateSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iKNCS.AiRefreshSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4AJjX.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dS67T.JswDoubleFeatureSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fCRLS.IntegrationsSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhk17la"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6PlQY.TestimonialSection), {}),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ihq7I.ClosingBanner), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iFk4q.Footer), {})
                    ]
                })
            })
        ]
    });
};
const $9c557963d1338261$var$sectionContainerStyles = null;
const $9c557963d1338261$var$backgroundStyles = null;

});
parcelRegister("iKNCS", function(module, exports) {
$parcel$export(module.exports, "AiRefreshSection", function () { return $b7205ca5f6b32aa0$export$53cedacbbc185d7; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $f11bi = parcelRequire("f11bi");

var $32ng3 = parcelRequire("32ng3");

var $kgXas = parcelRequire("kgXas");

var $b3ukl = parcelRequire("b3ukl");

var $hLTRc = parcelRequire("hLTRc");
const $b7205ca5f6b32aa0$export$53cedacbbc185d7 = ()=>{
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    if (useGWP7617Gate) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $b3ukl.FeaturedInfoSection), {
        variant: (0, $b3ukl.LAUNCH),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.AiRefreshSection.eyebrow",
            defaultMessage: "Plan, Track, and Collaborate"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.AiRefreshSection.heading",
            defaultMessage: "Where your team + AI come together"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.AiRefreshSection.description",
            defaultMessage: "Jira\u2019s AI helps teams drive better outcomes, faster."
        }),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                video: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/374p64xck763gywok4l212n24sji512r.mp4",
                    controls: false,
                    autoplay: true,
                    muted: true,
                    loop: true,
                    width: 1300,
                    height: 694
                },
                Icon: (0, $hLTRc.TimelineIcon),
                title: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card1.Title",
                    defaultMessage: "Jumpstart planning"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card1.Description",
                    defaultMessage: "Create work items from your favorite tools, then use AI to break down big ideas, polish descriptions, and link relevant resources in a snap."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ai-refresh/workflow-builder.webp",
                        alt: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card2.ImageAlt",
                            defaultMessage: "Shared release date module in Jira"
                        })
                    }
                },
                Icon: (0, $hLTRc.RedoIcon),
                title: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card2.Title",
                    defaultMessage: "Focus on impact"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card2.Description",
                    defaultMessage: "Cut down on admin with AI agents that make it easier to create project plans, identify trends, and flag potential risks."
                }),
                ctaProps: {
                    link: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card2.LinkText",
                            defaultMessage: "Meet Rovo agents"
                        }),
                        href: "/software/rovo/use-cases?feature=agent&"
                    }
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ai-refresh/linked-work-items.webp",
                        alt: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card3.ImageAlt",
                            defaultMessage: "Shared release date module in Jira"
                        })
                    }
                },
                Icon: (0, $hLTRc.FastIcon),
                title: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card3.Title",
                    defaultMessage: "Stay in sync"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card3.Description",
                    defaultMessage: "Surface related work, summarize lengthy comments, and connect work to company goals to give your team the details they need to work faster and make better decisions."
                }),
                ctaProps: {
                    link: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card3.LinkText",
                            defaultMessage: "Explore AI features"
                        }),
                        href: "/software/jira/ai"
                    }
                }
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kgXas.Ai), {});
};

});
parcelRegister("kgXas", function(module, exports) {
$parcel$export(module.exports, "Ai", function () { return $f3edea71192b0806$export$7ae07b56aa46260e; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $5qUgh = parcelRequire("5qUgh");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $ahPqL = parcelRequire("ahPqL");
parcelRequire("c48bY");
var $1pbCD = parcelRequire("1pbCD");
const $f3edea71192b0806$export$7ae07b56aa46260e = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8e22h.default)();
    const title = formatMessage({
        id: "jira-product-tour.ai-section.title-text",
        defaultMessage: "Your next move, suggested by AI"
    });
    const subTitle = formatMessage({
        id: "jira-product-tour.ai-section.subtitle-text",
        defaultMessage: "Atlassian Intelligence takes your big ideas and automatically suggests the tasks to help get it done."
    });
    const buttonText = formatMessage({
        id: "jira-product-tour.ai-section.button-text",
        defaultMessage: "Explore Atlassian Intelligence"
    });
    const videoLink = (0, $ahPqL.getAiVideo)(locale);
    const imageLink = (0, $ahPqL.getAiImage)(locale);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-ai-button-clicked",
                section: "ai-section"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _6a6z1h6o _bfhk17la _syazu67f _ca0qvbgk _u5f39by0 _n3tdvbgk _19bv9by0 _zulpzwfg"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1pbCD.Intelligence), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_1wybckbl _k48p1fw0 _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _flz0zwfg _1lzozwfg _1cqs1tcg"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syazcd5j _y3gn1h6o _ect4bzd7 _1wyb7vkz _k48p1nn1"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                        },
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1tz91y44 _1k797vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                            variant: "secondary",
                            color: "white",
                            colorAgainst: "other",
                            size: "large",
                            href: (0, $kooLp.useLocalizedHref)("/software/jira/ai"),
                            onClick: handleClick,
                            dataEventProps: {
                                "data-product-key": "jira",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-label": "explore-atlassian-intelligence",
                                "data-label-english": `${buttonText}`,
                                "data-track-event": "jira-pt.ai-section.explore-atlassian-intelligence"
                            },
                            children: buttonText
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                        playsInline: true,
                        muted: true,
                        preload: "auto",
                        autoPlay: true,
                        loop: true,
                        controls: true,
                        className: (0, $2jatx.default)([
                            "_p12f1uof _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _19451ogm _liwcglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                            src: videoLink,
                            type: "video/mp4"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: imageLink,
                            alt: "",
                            width: 2752,
                            height: 1838
                        },
                        className: (0, $2jatx.default)([
                            "_mezj1osq _bna71wug _14bq7vkz _3tce7vkz _1ym67vkz _1xr17vkz _1z4kglyw"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1tkemgvx _12vemgnk _ouxlbbky _1lrwykpt _1itkoro1 _1jgo1wqb _1w8u1dh4"
                ])
            })
        ]
    });
};
const $f3edea71192b0806$var$aiSectionStyles = null;
const $f3edea71192b0806$var$imageStyles = null;
const $f3edea71192b0806$var$videoStyles = null;
const $f3edea71192b0806$var$titleStyles = null;
const $f3edea71192b0806$var$subTitleStyles = null;
const $f3edea71192b0806$var$buttonStyles = null;
const $f3edea71192b0806$var$footerStyles = null;

});
parcelRegister("c48bY", function(module, exports) {
$parcel$export(module.exports, "Intelligence", function () { return (parcelRequire("1pbCD")).Intelligence; });
parcelRequire("1pbCD");

});



parcelRegister("Tm4Gw", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageBannerAlert", function () { return $581896a3442fe3b7$export$5f2661a957aa01ba; });

var $7VQPk = parcelRequire("7VQPk");

var $k3xrk = parcelRequire("k3xrk");
const $581896a3442fe3b7$export$5f2661a957aa01ba = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k3xrk.GWP8238AcquisitionBanner), {
        productKey: "jiraSoftware",
        identifier: "JiraSoftwarePageTemplate.banner.gwp-8238-announcement",
        ufoSegmentName: "jira-software-bannerAlert-gwp8238",
        testId: "gwp-8238-announcement-jira",
        linkTextId: "JiraSoftwarePage.banner-alert.gwp-8238-announcement.link-text",
        linkTextDefault: "Learn more"
    });
};

});
parcelRegister("k3xrk", function(module, exports) {
$parcel$export(module.exports, "GWP8238AcquisitionBanner", function () { return $8c4f05102dffb3c9$export$21516a4ccbdd4e52; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");

var $dEFIL = parcelRequire("dEFIL");
const $8c4f05102dffb3c9$var$AcquisitionAnnouncementDetail = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BannerAlert.gwp-8238-announcement.event-details",
        defaultMessage: "<strong>Breaking news:</strong> DX to join Atlassian!",
        values: (0, $kooLp.DEFAULT_VALUES)
    });
const $8c4f05102dffb3c9$export$21516a4ccbdd4e52 = ({ productKey: productKey, identifier: identifier, ufoSegmentName: ufoSegmentName, testId: testId, linkTextId: linkTextId = "BannerAlert.gwp-8238-announcement.link-text", linkTextDefault: linkTextDefault = "Learn more" })=>{
    const intl = (0, $8e22h.default)();
    if (!(0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8238BannerAnnouncement)) return null;
    const linkText = intl.formatMessage({
        id: linkTextId,
        defaultMessage: linkTextDefault
    });
    const acquisitionAnnouncementConfig = {
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg",
            alt: "DX",
            width: 50
        },
        imageMobileProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg",
            alt: "DX",
            width: 50
        },
        identifier: identifier,
        text: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)($8c4f05102dffb3c9$var$AcquisitionAnnouncementDetail, {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "data-testid": testId
                })
            ]
        }),
        mobileText: /*#__PURE__*/ (0, $7VQPk.jsx)($8c4f05102dffb3c9$var$AcquisitionAnnouncementDetail, {}),
        productKey: productKey,
        backgroundPreset: "gwp-8238-announcement",
        linkText: linkText,
        linkUrl: "https://www.atlassian.com/blog/announcements/atlassian-acquires-dx",
        dataEventProps: {
            "data-product-key": productKey,
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": linkText,
            "data-label-english": "Learn more"
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: ufoSegmentName,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEFIL.EnhancedBannerAlert), (0, $6ogO3._)({}, acquisitionAnnouncementConfig))
    });
};

});


parcelRegister("73ThH", function(module, exports) {
$parcel$export(module.exports, "GartnerSection", function () { return $b4828e26cb60559a$export$4c6bc3f3981e1f4c; });
/* gartner-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $ea4mV = parcelRequire("ea4mV");
const $b4828e26cb60559a$var$GartnerStyles = null;
const $b4828e26cb60559a$export$4c6bc3f3981e1f4c = ({ experimentEnabled: experimentEnabled })=>{
    const getGwp4948GartnerJiraProductTourExperiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwp4948GartnerJiraProductTourExperiment);
    const gwp4948GartnerJiraProductTourExperimentIsActive = experimentEnabled || getGwp4948GartnerJiraProductTourExperiment != undefined && getGwp4948GartnerJiraProductTourExperiment.type === "enrolled" && getGwp4948GartnerJiraProductTourExperiment.value === "test";
    const intl = (0, $8e22h.default)();
    const gartnerImage = // eslint-disable-next-line local/no-non-orangelogic-images-eslint
    "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner-jsw-left-img.webp";
    const gartnerMarketingHref = (0, $kooLp.useLocalizedHref)("https://www.atlassian.com/gartner/magic-quadrant-marketing-work-management");
    const gartnerDevopsHref = (0, $kooLp.useLocalizedHref)("https://www.atlassian.com/gartner/magic-quadrant-devops");
    const gartnerMarketingLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: gartnerMarketingHref,
            children: children
        });
    const gartnerDevopsLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: gartnerDevopsHref,
            children: children
        });
    if (gwp4948GartnerJiraProductTourExperimentIsActive) return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _vwz410nf _1bah1h6o _ca0q53f4 _u5f3idpf _n3td12am _19bvidpf _1pfhkgzx _1itk1a3y _43ds17la _11eb8pqr _d62sidpf _dubxo1fv"
        ]),
        style: {
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: gartnerImage,
                        alt: ""
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            children: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.GartnerSection.header",
                                defaultMessage: "Atlassian named a Leader in the 2024 Gartner\xae Magic Quadrant"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "JiraSoftwarePageTemplate.GartnerSection.body",
                            defaultMessage: `The best work management solution for all teams \u{2014} Atlassian is the only platform to be recognized as a Leader for both <gartnerMarketingLink>Marketing</gartnerMarketingLink> and <gartnerDevopsLink>DevOps</gartnerDevopsLink>`,
                            values: {
                                gartnerMarketingLink: gartnerMarketingLink,
                                gartnerDevopsLink: gartnerDevopsLink
                            }
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
};

});

parcelRegister("7J8Er", function(module, exports) {
$parcel$export(module.exports, "BuildAndSupportDoubleFeatureSection", function () { return (parcelRequire("4AJjX")).default; });
$parcel$export(module.exports, "JswCollaborateSection", function () { return (parcelRequire("bRgjW")).JswCollaborateSection; });
$parcel$export(module.exports, "JswDoubleFeatureSection", function () { return (parcelRequire("dS67T")).JswDoubleFeatureSection; });
$parcel$export(module.exports, "TestimonialSection", function () { return (parcelRequire("6PlQY")).TestimonialSection; });
$parcel$export(module.exports, "ClosingBanner", function () { return (parcelRequire("ihq7I")).ClosingBanner; });
$parcel$export(module.exports, "IntegrationsSection", function () { return (parcelRequire("fCRLS")).IntegrationsSection; });
$parcel$export(module.exports, "NoJiraHeroSection", function () { return (parcelRequire("1i0Tw")).NoJiraHeroSection; });

var $4AJjX = parcelRequire("4AJjX");

var $ihq7I = parcelRequire("ihq7I");

var $fCRLS = parcelRequire("fCRLS");

var $bRgjW = parcelRequire("bRgjW");

var $dS67T = parcelRequire("dS67T");

var $1i0Tw = parcelRequire("1i0Tw");

var $6PlQY = parcelRequire("6PlQY");

});
parcelRegister("4AJjX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5f8bab4e5d7d8552$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");

var $eO8Mp = parcelRequire("eO8Mp");

var $ahPqL = parcelRequire("ahPqL");
const $5f8bab4e5d7d8552$var$BuildAndSupportDoubleFeatureSection = ()=>{
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const tailoredHeadingText = useGWP7617Gate ? intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.header-text-gwp-7617",
        defaultMessage: "Tailor for your team"
    }) : intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.second-feature-header-text",
        defaultMessage: "Tailor it for your team"
    });
    const tailoredBodyText = useGWP7617Gate ? intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.second-feature-body-text-gwp-7617",
        defaultMessage: "Customize Jira to match your team\u2019s processes, workflows, language, and more. Integrate with every tool you use to get work done. "
    }) : intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.second-feature-body-text",
        defaultMessage: "Configure Jira to match your team\u2019s processes, workflows, language, and more. Integrate with every tool you use to get work done."
    });
    const tailoredLinkNew = (0, $kooLp.useLocalizedHref)("/software/jira/guides/getting-started/basics#step-3-set-up-your-columns");
    const tailoredLinkOld = (0, $kooLp.useLocalizedHref)("/software/jira/guides/issues/overview#what-is-an-issue");
    const tailoredLink = useGWP7617Gate ? tailoredLinkNew : tailoredLinkOld;
    const featureData = [
        {
            headingText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-header-text",
                defaultMessage: "Everything in one place"
            }),
            bodyText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-body-text",
                defaultMessage: "The context you need, when you need it. See software team release dates, real-time views of Figma designs, and more, all inside Jira."
            }),
            linkText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                defaultMessage: "Explore features"
            }),
            linkUrl: (0, $kooLp.useLocalizedHref)("/software/jira/features"),
            imageLink: (0, $ahPqL.getStaggeredDoubleFeautureFirstImage)(intl.locale),
            analyticsEventLabel: "atlas-55799-jira-features-button-clicked",
            imageHeight: 440
        },
        {
            headingText: tailoredHeadingText,
            bodyText: tailoredBodyText,
            linkText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.second-feature-link-text",
                defaultMessage: "Learn more"
            }),
            linkUrl: tailoredLink,
            imageLink: (0, $ahPqL.getStaggeredDoubleFeautureSecondImage)(intl.locale),
            analyticsEventLabel: "atlas-55799-jira-issues-button-clicked",
            imageHeight: 490
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eO8Mp.StaggeredFeatureList), {
        mainHeadingText: intl.formatMessage({
            id: "jira-product-tour.staggered-double-feature-section.header-text",
            defaultMessage: "Bring every team together under one roof"
        }),
        subHeadingText: intl.formatMessage({
            id: "jira-product-tour.staggered-double-feature-section.subheader-text",
            defaultMessage: "Spend less time trying to get aligned and more time driving projects forward with confidence."
        }),
        featureData: featureData,
        startingImagePosition: "left"
    });
};
$5f8bab4e5d7d8552$var$BuildAndSupportDoubleFeatureSection.displayName = "BuildAndSupportDoubleFeatureSection";
var $5f8bab4e5d7d8552$export$2e2bcd8739ae039 = $5f8bab4e5d7d8552$var$BuildAndSupportDoubleFeatureSection;

});
parcelRegister("eO8Mp", function(module, exports) {
$parcel$export(module.exports, "StaggeredFeatureList", function () { return $9992b1ac5c0075b5$export$5bd229e30bf4ab20; });
/* staggered-feature-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $2lwXu = parcelRequire("2lwXu");
const $9992b1ac5c0075b5$var$containerStyle = null;
const $9992b1ac5c0075b5$var$mainHeadingTextStyle = null;
const $9992b1ac5c0075b5$var$subHeadingTextStyle = null;
const $9992b1ac5c0075b5$var$featureContainerStyle = null;
const $9992b1ac5c0075b5$var$featureImageContainerStyle = null;
const $9992b1ac5c0075b5$var$featureBodyContainerStyle = null;
const $9992b1ac5c0075b5$var$featureLinkStyles = null;
const $9992b1ac5c0075b5$var$featureHeadingTextStyle = null;
const $9992b1ac5c0075b5$var$featureBodyTextStyle = null;
const $9992b1ac5c0075b5$var$Feature = ({ featureData: featureData, imagePosition: imagePosition })=>{
    if (imagePosition === "left") return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1pfhvbgk _79ty1bp4 _1np61h6o _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureImage, (0, $6ogO3._)({}, featureData)),
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureBody, (0, $6ogO3._)({}, featureData))
        ]
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1pfhvbgk _79ty1bp4 _1np61h6o _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureBody, (0, $6ogO3._)({}, featureData)),
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureImage, (0, $6ogO3._)({}, featureData))
        ]
    });
};
const $9992b1ac5c0075b5$var$FeatureImage = ({ imageLink: imageLink, imageHeight: imageHeight })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1tvckb7n _1rwy1tcg _1y8o1ogm _bna71ns9 _rtys1ogm _1lre1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
            image: {
                src: imageLink,
                alt: "",
                width: 600,
                height: imageHeight
            }
        })
    });
};
const $9992b1ac5c0075b5$var$FeatureBody = ({ headingText: headingText, bodyText: bodyText, linkUrl: linkUrl, linkText: linkText, analyticsEventLabel: analyticsEventLabel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: `${analyticsEventLabel}`,
                section: "staggered-feature-section"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1o9zgrho _4cvr1h6o _1pfhvrzy _1bsb1diq _zulpftgi _1tvccs5v _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _ect41pz4 _k48p1fw0 _vwz410mc _slp31hna _195gidpf _1mouidpf _y3gn1h6o"
                ]),
                style: {
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                },
                children: headingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _ect4bzd7 _k48p1nn1 _vwz41gkc _slp31hna _y3gn1h6o _p12fng7t _ca0qidpf _u5f310yn _n3tdidpf _19bv10yn _1y8o1osq"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                },
                children: bodyText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                href: linkUrl,
                onClick: handleClick,
                "aria-label": formatMessage({
                    id: "learnMoreAbout",
                    defaultMessage: "Learn more about {subject}"
                }, {
                    subject: headingText
                }),
                className: (0, $2jatx.default)([
                    "_syaz17la"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                },
                children: [
                    linkText,
                    " ",
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2lwXu.ArrowRightNoCircle), {})
                ]
            })
        ]
    });
};
const $9992b1ac5c0075b5$export$5bd229e30bf4ab20 = ({ mainHeadingText: mainHeadingText, subHeadingText: subHeadingText, featureData: featureData, startingImagePosition: startingImagePosition })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1mou16xz _195gidpf _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _91qc9by0 _1x7014no"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect41pz4 _1wybckbl _zg8l4jg8 _k48p1fw0 _slp31hna _flz0zwfg _1lzozwfg _1cqs1ul9"
                ]),
                style: {
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                },
                children: mainHeadingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4bzd7 _1wybgktf _zg8l4jg8 _k48p1nn1 _vwz41f4h _1pfh7vkz _1bsbbxu3 _79ty1bp4 _1np61h6o _1rwy1tcg _7se29by0 _zzrm1osq _s637jwe6"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                },
                children: subHeadingText
            }),
            featureData.map((feature, index)=>index % 2 === 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$Feature, {
                    imagePosition: startingImagePosition === "left" ? "left" : "right",
                    featureData: feature
                }, index) : /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$Feature, {
                    imagePosition: startingImagePosition === "left" ? "right" : "left",
                    featureData: feature
                }, index))
        ]
    });
};

});
parcelRegister("2lwXu", function(module, exports) {
$parcel$export(module.exports, "ArrowRightNoCircle", function () { return $bbe047a4ec4aed29$export$c6abe79c9e2193ff; });

var $7VQPk = parcelRequire("7VQPk");
const $bbe047a4ec4aed29$export$c6abe79c9e2193ff = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });

});



parcelRegister("ihq7I", function(module, exports) {
$parcel$export(module.exports, "ClosingBanner", function () { return $683d4f00c3f6f587$export$3c134be78c4f7e1c; });
/* closing-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $5qUgh = parcelRequire("5qUgh");

var $jmley = parcelRequire("jmley");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $683d4f00c3f6f587$export$3c134be78c4f7e1c = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const text = useGWP7617Gate ? formatMessage({
        id: "jira-product-tour.closing-banner.header-text-gwp-7617",
        defaultMessage: "No matter what you dream up, Jira helps you get it done."
    }) : formatMessage({
        id: "jira-product-tour.closing-banner.header-text",
        defaultMessage: "No matter what you're trying to dream up, Jira helps you get it done"
    });
    const buttonText = formatMessage({
        id: "jira-product-tour.closing-banner.button-text",
        defaultMessage: "Get Jira free"
    });
    const ctaButtonUrl = "/try/cloud/signup?bundle=jira-software";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1b1v _4cvr1h6o _p12f1dho _19pkidpf _2hwx1wug _otyridpf _18u01wug _1eogidpf _qjx39by0 _1celidpf _5n7a9by0 _1gde1bp4 _nssp1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _zulp1ylp _144t1wqb _zzsz1h6o _1tz91y44"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_p12fntfb _ect41pz4 _k48p1fw0 _1wyb1ylp _vwz4ckbl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazcd5j _xsmr1h6o _1cqs1ul9 _1bys14no"
                        ]),
                        style: {
                            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: text
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jmley.default), {
                        intentType: "button",
                        containerId: "jira-product-tour-overview-closing-banner",
                        productKey: "jira-software.ondemand",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                            variant: "primary",
                            size: "small",
                            color: "yellow",
                            href: (0, $kooLp.useLocalizedHref)(ctaButtonUrl),
                            dataEventProps: {
                                "data-product-key": "jira",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-label": "get-jira-free",
                                "data-label-english": `${buttonText}`,
                                "data-track-event": "jira-pt.closing-banner.get-jira-free"
                            },
                            children: buttonText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1bsbhvew _4t3ieq5r _1wpzh9n0 _1wn41h6o _1tvd1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_mezjhvew _bna7eq5r"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/865y3n8f2i1843j2vs45535l48vtx77r.webp",
                                alt: "",
                                width: 303,
                                height: 303
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152t1skh _1e021wqb"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/xbvh6b7g0mjibasf143rj6711054m0cf.webp",
                                alt: "",
                                width: 95,
                                height: 97
                            }
                        })
                    })
                ]
            })
        ]
    });
};
$683d4f00c3f6f587$export$3c134be78c4f7e1c.displayName = "ClosingBanner";
const $683d4f00c3f6f587$var$ctaBannerContainer = null;
const $683d4f00c3f6f587$var$contentContainer = null;
const $683d4f00c3f6f587$var$headerStyles = null;
const $683d4f00c3f6f587$var$imageContainer = null;
const $683d4f00c3f6f587$var$imageStyles = null;
const $683d4f00c3f6f587$var$overlayStarImage = null;

});

parcelRegister("fCRLS", function(module, exports) {
$parcel$export(module.exports, "IntegrationsSection", function () { return $adef94d25ceb314a$export$94c8b142f0acfaff; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kVWxs = parcelRequire("kVWxs");

var $32ng3 = parcelRequire("32ng3");
const $adef94d25ceb314a$export$94c8b142f0acfaff = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    // TODO: add width and height prop to iconData to use in Picture component
    const iconData = [
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/n773sikm845802hme5xs1ne04uy2g837.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.microsoft-alt-text",
                defaultMessage: "Microsoft Teams icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/s2b5621s46n36ogarwic4734b30xge4b.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.google-drive-alt-text",
                defaultMessage: "Google Drive icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/wrb81j78p4733kc10bdjw8v637h1w438.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.google-doc-alt-text",
                defaultMessage: "Google Docs icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/1m0x1742g31t1446203avy1kpi468me1.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.figma-alt-text",
                defaultMessage: "Figma icon"
            }),
            width: 48,
            height: 60
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/s2035t28j8p045avd6kjvjpr68g0uyfb.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.miro-alt-text",
                defaultMessage: "Miro icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/ow67lf57t0be1t6ami55288g1dx2kp46.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.slack-alt-text",
                defaultMessage: "Slack icon"
            }),
            width: 60,
            height: 58
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/uje2jom52scmv5bs8o1ej15sp162l6h0.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.zoom-alt-text",
                defaultMessage: "Zoom icon"
            }),
            width: 60,
            height: 13
        }
    ];
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-integrations-button-clicked",
                section: "integration-section"
            }
        }).fire();
    };
    const headingText = useGWP7617Gate ? intl.formatMessage({
        id: "jira-product-tour.integrations-section.heading-text-gwp-7617",
        defaultMessage: "Meet teams where they work"
    }) : intl.formatMessage({
        id: "jira-product-tour.integrations-section.heading-text",
        defaultMessage: "Meets teams where they work"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kVWxs.OffsetIconCollection), {
        headingText: headingText,
        bodyText: intl.formatMessage({
            id: "jira-product-tour.integrations-section.body-text",
            defaultMessage: "If your team uses it, we integrate with it. Easily add your favorite tools from the Atlassian Marketplace, keeping Jira as your central source of truth."
        }),
        iconData: iconData,
        ctaText: intl.formatMessage({
            id: "jira-product-tour.integrations-section.cta-text",
            defaultMessage: "Go to Marketplace"
        }),
        ctaLink: "https://marketplace.atlassian.com",
        ctaOnClickFunc: handleClick
    });
};
$adef94d25ceb314a$export$94c8b142f0acfaff.displayName = "IntegrationsSection";

});
parcelRegister("kVWxs", function(module, exports) {
$parcel$export(module.exports, "OffsetIconCollection", function () { return $bef0e19d7a97ecea$export$87daf6ae3676874; });
/* offset-icon-collection.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $imIsw = parcelRequire("imIsw");
const $bef0e19d7a97ecea$var$sectionContainer = null;
const $bef0e19d7a97ecea$var$contentContainer = null;
const $bef0e19d7a97ecea$var$textContainerStyles = null;
const $bef0e19d7a97ecea$var$headingTextStyles = null;
const $bef0e19d7a97ecea$var$ctaStyles = null;
const $bef0e19d7a97ecea$var$iconContainerStyles = null;
const $bef0e19d7a97ecea$var$iconPictureStyles = null;
const $bef0e19d7a97ecea$var$animationStyle = null;
const $bef0e19d7a97ecea$export$4b1f681ca613adbb = ({ src: src, alt: alt, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: src,
            alt: alt,
            width: width,
            height: height
        }
    });
};
const $bef0e19d7a97ecea$export$87daf6ae3676874 = ({ iconData: iconData, headingText: headingText, bodyText: bodyText, ctaText: ctaText, ctaLink: ctaLink, ctaOnClickFunc: ctaOnClickFunc })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _bfhk1hxd _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _1pbykb7n _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _p12f17gh _1mou1qr7 _liwc1txw _79ty1bp4 _1np61h6o _s637jwe6 _1eogidpf _qjx39by0 _1celidpf _5n7a9by0 _1x701ylp"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulp1ul9 _4cvr1y6m _syazqlpt _bozg1ul9 _m80d1h6o _79ty1bp4 _1np61h6o _s637jwe6 _1eogidpf _qjx310yn _1celidpf _5n7a10yn"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_k48p1fw0 _1wyb1wto _vwz4cjiy _1mouidpf _1r3wl07h"
                            ]),
                            children: headingText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            children: bodyText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: ctaLink,
                            onClick: ctaOnClickFunc,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                className: (0, $2jatx.default)([
                                    "_11q7glyw _1wyb1k92 _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _ect41kw7 _19it1axk _80omtlke"
                                ]),
                                children: ctaText
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    ref: scrollRef,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _i0dl1osq _zulp1wyk _1bah1h6o _ae4v1h6o _p12f18a8 _1o9zidpf _zzrm1kdj _1rwy1ylp"
                    ]),
                    children: iconData.map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            style: {
                                animationDelay: `${0.5 + 0.25 * index}s`
                            },
                            className: (0, $2jatx.default)([
                                "_2rko1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _tip8kb7n _5sagw1p3 _bfhku67f _1bsb53f4 _4t3i53f4 _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _vavro7ao _zzrmvbgk _1gdlvbgk _60iy1txw _2a1o1h6o _1biz1h6o _137x8tad _mgbt1343 _v1631fm0 _1vsm1fm0 _1v3g1fm0 _1vvw1fm0 _rtys1osq _19l31osq _mezj1wug _bna71wug",
                                sectionIsVisible && "_j7hq1nm9"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($bef0e19d7a97ecea$export$4b1f681ca613adbb, {
                                src: icon.url,
                                alt: icon.altText,
                                width: icon.width,
                                height: icon.height
                            })
                        }, index))
                })
            ]
        })
    });
};

});


parcelRegister("bRgjW", function(module, exports) {
$parcel$export(module.exports, "JswCollaborateSection", function () { return $0461ddbaa879edb2$export$46dbd2229fc0687f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("7P5uc");
var $h5cWZ = parcelRequire("h5cWZ");

var $ahPqL = parcelRequire("ahPqL");
const $0461ddbaa879edb2$export$46dbd2229fc0687f = ()=>{
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    // first item
    const firstFeatureDescriptionOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.first-feature-description-text",
        defaultMessage: "From short projects, to large cross-functional programs, Jira helps break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more."
    });
    const firstFeatureDescriptionAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.first-feature-description-text-ai",
        defaultMessage: "From short projects, to large cross-functional programs, Jira uses AI to help break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more."
    });
    // third item
    const thirdFeatureTitleOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-title-text",
        defaultMessage: "Track work your way"
    });
    const thirdFeatureTitleAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-title-text-ai",
        defaultMessage: "Work your way"
    });
    const thirdFeatureDescriptionOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-description-text",
        defaultMessage: "Visualize work with lists, boards, backlogs, and more. Make workflows for any process and integrate with tools you love."
    });
    const thirdFeatureDescriptionAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-description-text-ai",
        defaultMessage: "Keep Jira in sync with your favorite tools, customize your workflows with AI \u2013 and, stay on top of it all with lists, boards, and timeline views."
    });
    // fourth item
    const fourthFeatureTitleOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-title-text",
        defaultMessage: "Optimize with insights"
    });
    const fourthFeatureTitleAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-title-text-ai",
        defaultMessage: "Keep your projects on track"
    });
    const fourthFeatureDescriptionOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-description-text",
        defaultMessage: "Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance."
    });
    const fourthFeatureDescriptionAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-description-text-ai",
        defaultMessage: "Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance."
    });
    const options = [
        {
            title: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.first-feature-title-text",
                defaultMessage: "\u26A1 Plan and organize tasks"
            }),
            image: (0, $ahPqL.getCollaborateFirstImage)(intl.locale),
            description: useGWP7617Gate ? firstFeatureDescriptionAI : firstFeatureDescriptionOld
        },
        {
            title: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.second-feature-title-text",
                defaultMessage: "Align work to goals"
            }),
            image: (0, $ahPqL.getCollaborateSecondImage)(intl.locale),
            description: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.second-feature-description-text",
                defaultMessage: "Link work to goals so everyone can see how their work contributes to company objectives and stay aligned to what\u2019s important."
            })
        },
        {
            title: useGWP7617Gate ? thirdFeatureTitleAI : thirdFeatureTitleOld,
            image: (0, $ahPqL.getCollaborateThirdImage)(intl.locale),
            description: useGWP7617Gate ? thirdFeatureDescriptionAI : thirdFeatureDescriptionOld
        },
        {
            title: useGWP7617Gate ? fourthFeatureTitleAI : fourthFeatureTitleOld,
            image: (0, $ahPqL.getCollaborateFourthImage)(intl.locale),
            description: useGWP7617Gate ? fourthFeatureDescriptionAI : fourthFeatureDescriptionOld
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h5cWZ.JswCollaborate), {
        options: options,
        heading: intl.formatMessage({
            id: "jira-product-tour.collaborate-section.title-text",
            defaultMessage: "Made for complex projects or everyday tasks"
        })
    });
};
$0461ddbaa879edb2$export$46dbd2229fc0687f.displayName = "JswCollaborateSection";

});
parcelRegister("7P5uc", function(module, exports) {
$parcel$export(module.exports, "JswCollaborate", function () { return (parcelRequire("h5cWZ")).JswCollaborate; });
$parcel$export(module.exports, "JswDoubleFeatureCard", function () { return (parcelRequire("7asA7")).JswDoubleFeatureCard; });
$parcel$export(module.exports, "TestimonialCard", function () { return (parcelRequire("AR1pQ")).TestimonialCard; });
$parcel$export(module.exports, "LogoBanner", function () { return (parcelRequire("6V1n4")).LogoBanner; });
$parcel$export(module.exports, "Header", function () { return (parcelRequire("6Sktx")).Header; });
$parcel$export(module.exports, "HeroCards", function () { return (parcelRequire("7chqp")).HeroCards; });
parcelRequire("h5cWZ");
parcelRequire("7asA7");
parcelRequire("AR1pQ");
parcelRequire("6V1n4");
parcelRequire("6Sktx");
parcelRequire("7chqp");

});
parcelRegister("h5cWZ", function(module, exports) {
$parcel$export(module.exports, "JswCollaborate", function () { return $b8e4fdbb89836c28$export$b0665de8e27040dd; });
/* jsw-collaborate.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $b8e4fdbb89836c28$export$b0665de8e27040dd = ({ heading: heading, options: options })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const [activeOption, setActiveOption] = (0, $1oC0p.useState)(0);
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const changeActive = (index)=>{
        // Cancel all animations before activeOption change
        const progressGrowAnimations = document.getAnimations().filter((animation)=>{
            return animation instanceof CSSAnimation && animation.animationName === "progressgrow";
        });
        progressGrowAnimations.forEach((animation)=>{
            animation.cancel();
        });
        setActiveOption(index);
    };
    (0, $1oC0p.useEffect)(()=>{
        const progressGrowAnimations = document.getAnimations().filter((animation)=>{
            return animation instanceof CSSAnimation && animation.animationName === "progressgrow";
        });
        // set finish event
        progressGrowAnimations.forEach((animation)=>{
            animation.onfinish = ()=>{
                setActiveOption(activeOption == options.length - 1 ? 0 : activeOption + 1);
                animation.cancel();
            };
        });
        // Only cycle when visible
        if (!sectionIsVisible) progressGrowAnimations.forEach((animation)=>{
            animation.pause();
        });
        else progressGrowAnimations.forEach((animation)=>{
            animation.play();
        });
    }, [
        activeOption,
        options.length,
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c11p5 _6a6z1h6o _4cvr1h6o _1rjc12am _195gzwfg _1ilvzwfg _91qcidpf",
            sectionIsVisible ? "is-visible" : ""
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _91qc9by0 _8fz6e0nm _mezj1mcy _bna71k4y _5nenxk0h _twjk1qjk _14w91a70 _j0lcd4y9 _1jtm14no _rpid14y2 _1h8ed4y9 _1ga514no _1ftj14y2",
                    "top-section"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("h2", {
                    className: (0, $2jatx.default)([
                        "_k48p1fw0 _1wybckbl _vwz48vuz _19pkidpf _2hwxidpf _otyr1ul9 _18u0idpf _1r3w1ul9 _73n214no _z9soidpf _161zidpf _2a8ridpf _ikcgidpf"
                    ]),
                    children: [
                        heading,
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/s31k3rin80p38d25a3wn54b8354r27vm.webp",
                                alt: "",
                                width: 245,
                                height: 279
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_91qc9by0 _jzgezwfg _1q5112am _11q7cd5j",
                    "bottom-section"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "aria-label": formatMessage({
                        id: "jira-product-tour.collaborate-section.carousel",
                        defaultMessage: "Carousel"
                    }),
                    className: (0, $2jatx.default)([
                        "_p12f1uof _1e0c1txw _1n261g80 _zulpzwfg _zzrm1osq _79ty1bp4 _1np61h6o _9et11h6o _1yytidpf",
                        "row-width"
                    ]),
                    role: "region",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_i0dlbihp _kqswh2mm _cot22huk",
                                "half texts"
                            ]),
                            children: options.map((option, index)=>{
                                const src = (0, $hnmMQ.extendBfldrCacheTime)(option.image);
                                const isActive = activeOption == index;
                                return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: "option-container",
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                            className: (0, $2jatx.default)([
                                                "_11q7glyw _r06hglyw _1r04idpf _80omtlke _19itidpf _1wyb1j6v _y3gn1e5h _19pkidpf _2hwxidpf _otyrzwfg _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvgktf _kqswh2mm _4t3i1osq _1vdjzwfg _1bfn10mc _1mjg1tcg _kmcs1ul9 _zpjv1w81 _19141wug _h95w1gmh",
                                                `option ${activeOption == index ? "active" : "inactive"}`
                                            ]),
                                            onClick: ()=>changeActive(index),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_kqswstnw _1e02idpf _152tidpf _u7coidpf _1bsb1l7b _4t3i1osq _bfhk1kby",
                                                        "progress"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_bfhkoelr _4t3iidpf"
                                                        ])
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyb1tcg _vwz41ul9 _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _v5641fa5 _1496ni7l"
                                                    ]),
                                                    children: option.title
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_v5641qn0 _c71lidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq"
                                                    ]),
                                                    children: option.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0cglyw _liwc11p5 _9et11h6o _1np61h6o",
                                                "mobile-images"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                image: {
                                                    src: src,
                                                    alt: option.title
                                                },
                                                style: {
                                                    aspectRatio: "5/4",
                                                    display: isActive ? "block" : "none",
                                                    width: "100%",
                                                    height: "auto"
                                                },
                                                className: (0, $2jatx.default)([
                                                    "_kqswh2mm _p12f1ogm"
                                                ])
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            "aria-live": "polite",
                            className: (0, $2jatx.default)([
                                "_i0dlbihp _kqswh2mm _cot22huk",
                                "half images"
                            ]),
                            role: "status",
                            children: options.map((option, index)=>{
                                const src = (0, $hnmMQ.extendBfldrCacheTime)(option.image);
                                const isActive = activeOption == index;
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_liwcglyw",
                                        "desktop-images"
                                    ]),
                                    hidden: !isActive,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                        image: {
                                            src: src,
                                            alt: option.title
                                        },
                                        style: {
                                            aspectRatio: "5/4",
                                            position: "absolute",
                                            width: "100%",
                                            height: "auto"
                                        }
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $b8e4fdbb89836c28$var$topSectionForPictureStyles = null;
const $b8e4fdbb89836c28$var$mobileImagesStyles = null;
const $b8e4fdbb89836c28$var$desktopImagesStyles = null;
const $b8e4fdbb89836c28$var$rowWidthStyles = null;
const $b8e4fdbb89836c28$var$halfStyles = null;
const $b8e4fdbb89836c28$var$progressStyles = null;
const $b8e4fdbb89836c28$var$buttonStyles = null;
const $b8e4fdbb89836c28$var$optionDescriptionStyles = null;
const $b8e4fdbb89836c28$var$innerDivProgressStyles = null;
const $b8e4fdbb89836c28$var$optionH3Styles = null;
const $b8e4fdbb89836c28$var$bottomSectionStyles = null;
const $b8e4fdbb89836c28$var$optionContainerImageStyles = null;
const $b8e4fdbb89836c28$var$h2Styles = null;
const $b8e4fdbb89836c28$var$empowerStyles = null;

});

parcelRegister("7asA7", function(module, exports) {
$parcel$export(module.exports, "JswDoubleFeatureCard", function () { return $31657ce82e95d787$export$881c15c7192d6044; });
/* double-feature-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $31657ce82e95d787$export$881c15c7192d6044 = ({ title: title, description: description, image: image })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _1bsb1diq _zulp1gkc _11q7cd5j _16qs188r _1y8o1diq _zzrm1osq"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_mezj1osq _bna71osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: image,
                        alt: ""
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_syaz1hlo _y3gn1h6o _ect41pz4 _1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaz1hlo _y3gn1h6o _ect4bzd7 _1wybo7ao _k48p1nn1 _vwz41gkc _ca0qftgi _u5f353f4 _n3td8ved _19bv53f4 _1eogftgi _qjx310yn _1cel10yn _5n7a10yn"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                        },
                        children: description
                    })
                ]
            })
        ]
    });
};
const $31657ce82e95d787$var$cardStyle = null;
const $31657ce82e95d787$var$titleStyles = null;
const $31657ce82e95d787$var$descriptionStyles = null;
const $31657ce82e95d787$var$imageContainerStyle = null;

});

parcelRegister("AR1pQ", function(module, exports) {
$parcel$export(module.exports, "TestimonialCard", function () { return $755c5031f1e223bd$export$a34a40ba0fc7f13f; });
/* testimonial-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");
const $755c5031f1e223bd$export$e4a9ef29ffd77837 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsb9by0 _rjxp4l2f _152t1vmu _1mjbglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8egyb3e0hgar3nj26we824nso1lfh124.webp",
                alt: "",
                width: 78,
                height: 47
            }
        })
    });
};
const $755c5031f1e223bd$export$8c97d8ed71074b34 = ({ image: image })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ahbq1hnc _1pfh1hnc _mezj1w6l _bna75k64"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: image,
                alt: "",
                width: 255,
                height: 238
            }
        })
    });
};
const $755c5031f1e223bd$export$a34a40ba0fc7f13f = ({ image: image, quote: quote, name: name, title: title })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($755c5031f1e223bd$export$e4a9ef29ffd77837, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _syazr3uz _p12f1kqb _85i510yn _bfhku67f _2rko1uj0 _1gde1bp4 _1rkbjwe6"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($755c5031f1e223bd$export$8c97d8ed71074b34, {
                        image: image
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb17ek _ahbq16gx _1qoxo7ao _suga1txw _1gde1bp4 _nssp1h6o _chtu1ou6 _v7361ou6"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1k92 _syaz1yn5 _ect41td8 _1rkbncxg _q5ug1pa9 _7tld182x _14adidpf _4uroidpf _1cqsgktf _1bys1f4h _18ghnl7k _chtu1ou6",
                                    "quote"
                                ]),
                                children: [
                                    "\u201C",
                                    quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
                                className: (0, $2jatx.default)([
                                    "_1bsb19n7 _4t3it94y _syaz9sh9 _19pk7vkz _2hwxidpf _otyridpf _18u0idpf _1rfmajfg"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wybqgp8 _k48pni7l _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "name"
                                ]),
                                children: name
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybgktf _ui901hgu _62c41qje _1jw81nn1 _1bys1tcg _1rkb1rr2",
                                    "title"
                                ]),
                                children: title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $755c5031f1e223bd$var$cardContainerStyles = null;
const $755c5031f1e223bd$var$testimonialQuoteImageStyles = null;
const $755c5031f1e223bd$var$testimonialQuotesSectionStyles = null;
const $755c5031f1e223bd$var$customerImagePictureStyles = null;
const $755c5031f1e223bd$var$quoteContainerStyles = null;
const $755c5031f1e223bd$var$quoteStyles = null;
const $755c5031f1e223bd$var$hrContainerStyles = null;
const $755c5031f1e223bd$var$nameStyles = null;
const $755c5031f1e223bd$var$titleStyles = null;

});

parcelRegister("6V1n4", function(module, exports) {
$parcel$export(module.exports, "LogoBanner", function () { return $ff933ff67f9e4e4b$export$f856413bacaabd31; });
/* logo-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $ahPqL = parcelRequire("ahPqL");
const $ff933ff67f9e4e4b$var$svgArray = [
    (0, $ahPqL.NasaLogo),
    (0, $ahPqL.AirCanadaLogo),
    (0, $ahPqL.VisaLogo),
    (0, $ahPqL.CanvaLogo),
    (0, $ahPqL.DominosLogo),
    (0, $ahPqL.FordLogo)
];
const $ff933ff67f9e4e4b$export$f856413bacaabd31 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk1hxd _mkrztcy0 _1qv2ewaa"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                "_qtt8glyw _ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _tzy415iw _p12f2w76 _19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx2vrvc _4cvr1h6o _1bahitcz _1eog1ul9 _qjx3idpf _1cel1ul9 _5n7aidpf _liwc11p5 _13gz16hb _9et11h6o _17sl19q2 _4pgi1hwe _1fu1116b _eulesxk5 _tme71sp7 _1odz101s _r5d653f4 _b3uv1f06 _1avyys9h"
            ]),
            children: $ff933ff67f9e4e4b$var$svgArray.map((Component, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    id: `item-${idx}`,
                    className: (0, $2jatx.default)([
                        "_syaz1yg0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _cjbs1ylp _12ra68cl"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)(Component, {})
                }, idx))
        })
    });
};
$ff933ff67f9e4e4b$export$f856413bacaabd31.displayName = "LogoBanner";
const $ff933ff67f9e4e4b$var$logoBannerStyles = null;
const $ff933ff67f9e4e4b$var$logoContainerStyles = null;
const $ff933ff67f9e4e4b$var$logoStyles = null;

});

parcelRegister("6Sktx", function(module, exports) {
$parcel$export(module.exports, "Header", function () { return $32314b1200b84dcf$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $5qUgh = parcelRequire("5qUgh");

var $5kPBa = parcelRequire("5kPBa");

var $gfjAv = parcelRequire("gfjAv");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");
const $32314b1200b84dcf$export$8b251419efc915eb = ()=>{
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: "/try/cloud/signup?bundle=jira-software"
    });
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const subHeading = formatMessage({
        id: "jira-product-tour.hero-header.sub-header-text",
        defaultMessage: "The only project management tool you need to plan and track work across every team."
    });
    const buttonText = formatMessage({
        id: "jira-product-tour.hero-header.button-text",
        defaultMessage: "Get Jira free"
    });
    const mainHeading = formatMessage({
        id: "jira-product-tour.hero-header.header-text",
        defaultMessage: "<strong>Great outcomes</strong> start with <em>Jira</em>"
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                className: (0, $2jatx.default)([
                    "_k48p8n31 _1e0c1ule _181n1nu9"
                ]),
                children: text
            }),
        em: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("em", {
                className: (0, $2jatx.default)([
                    "_zg8l4jg8 _kqswh2mm _3p6m49fr _1v5vmgnk _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                ]),
                children: text
            })
    });
    const handleClick = (e)=>{
        if (openCrossFlow) openCrossFlow(e);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _6a6z1h6o _1q51vbgk _jzgezwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_syaz1hlo _1wyb14no _k48p4jg8 _vwz41gnr _19pkidpf _2hwx1crf _otyr1crf _18u01crf _y3gn1h6o _flz0ckbl _fz891k4y"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: mainHeading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ect4bzd7 _k48p1nn1 _1wybgktf _vwz41f4h _y3gn1h6o _syaz1hlo _ca0qidpf _u5f39by0 _n3td1ylp _19bv9by0 _so7d7vkz _19q11ou6 _tl28idpf _axwix19p _1hwc1ylp _sp8tx19p"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: subHeading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                intentType: "button",
                containerId: "heroSection",
                productKey: "jira-software.ondemand",
                edition: "free",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                    onClick: handleClick,
                    href: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software"),
                    variant: "primary",
                    size: "large",
                    color: "blue",
                    dataEventProps: {
                        "data-product-key": "jira",
                        "data-event": "clicked",
                        "data-event-component": "button",
                        "data-event-container": "heroSection",
                        "data-label": "get-jira-free",
                        "data-label-english": "Get Jira Free",
                        "data-track-event": "jira-pt.hero-cta.get-jira-free"
                    },
                    children: buttonText
                })
            })
        ]
    });
};
const $32314b1200b84dcf$var$sectionStyles = null;
const $32314b1200b84dcf$var$subheadingStyles = null;
const $32314b1200b84dcf$var$mainHeadingStyles = null;
const $32314b1200b84dcf$var$mainHeadingStrongStyles = null;
const $32314b1200b84dcf$var$mainHeadingEmStyles = null;

});

parcelRegister("7chqp", function(module, exports) {
$parcel$export(module.exports, "HeroCards", function () { return $d73711ffa20ae17c$export$fd47e26e7f1281cb; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $3L8ZR = parcelRequire("3L8ZR");

var $kbpa7 = parcelRequire("kbpa7");

var $iNnWi = parcelRequire("iNnWi");

var $6FYDc = parcelRequire("6FYDc");

var $6tzCE = parcelRequire("6tzCE");

var $3FT2j = parcelRequire("3FT2j");

var $b2wEL = parcelRequire("b2wEL");
const $d73711ffa20ae17c$export$fd47e26e7f1281cb = ()=>{
    const intl = (0, $8e22h.default)();
    const itModalUpdate = (0, $3L8ZR.default).checkGate("it-copy-and-image-update");
    const softwareCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-software-development-card.eyebrow-text",
            defaultMessage: "product & issue tracking"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-software-development-card.title-text",
            defaultMessage: "Software Development"
        }),
        image: (0, $iNnWi.getHeroCardSoftwareDevelopmentImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.OrangeCard),
        label: "software-development"
    };
    const marketingCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-marketing-card.eyebrow-text",
            defaultMessage: "plan & launch campaigns"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-marketing-card.title-text",
            defaultMessage: "Marketing"
        }),
        image: (0, $iNnWi.getHeroCardMarketingImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.PurpleCard),
        label: "marketing"
    };
    const itCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-it-card.eyebrow-text",
            defaultMessage: "manage & track requests"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-it-card.title-text",
            defaultMessage: "IT"
        }),
        image: (0, $iNnWi.getHeroCardItImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.GreenCard),
        label: "it"
    };
    const updatedItCard = (0, $dPABA._)((0, $6ogO3._)({}, itCard), {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-it-card.updated-eyebrow-text",
            defaultMessage: "plan & track it projects"
        })
    });
    const designCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-design-card.eyebrow-text",
            defaultMessage: "build creative workflows"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-design-card.title-text",
            defaultMessage: "Design"
        }),
        image: (0, $iNnWi.getHeroCardDesignImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.BlueCard),
        label: "design"
    };
    const operationsCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-operations-card.eyebrow-text",
            defaultMessage: "create custom processes"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-operations-card.title-text",
            defaultMessage: "Operations"
        }),
        image: (0, $iNnWi.getHeroCardOperationsImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.BlackCard),
        label: "operations"
    };
    // @ts-ignore
    const finalUpdatedItCard = itModalUpdate ? updatedItCard : itCard;
    const heroCardText = [
        softwareCard,
        marketingCard,
        updatedItCard,
        designCard,
        operationsCard
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b2wEL.HeroContextProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _1bah1y6m _1bsb1osq _p12f1ns9 _zulp7vkz _1reo1wug _12l21wug _ahbq1wug _ca0qvbgk _u5f319bv _n3td19bv _19bv19bv _a5o9coo4 _jzge1l27 _105s1y6m _2g9e19bv _1rwy1l7b _1w1e15zi _z6961l7b"
            ]),
            style: {
                "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800"))
            },
            children: [
                heroCardText.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6FYDc.HeroCard), {
                        eyebrow: card.eyebrow,
                        title: card.title,
                        image: card.image,
                        BackgroundImage: card.BackgroundImage,
                        idx: index,
                        label: card.label
                    }, index)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3FT2j.JswProductModalCarousel), {})
            ]
        })
    });
};
const $d73711ffa20ae17c$var$heroCardsStyling = null;

});
parcelRegister("6FYDc", function(module, exports) {
$parcel$export(module.exports, "HeroCard", function () { return $cd3457d7154b039d$export$57301f0520e516bf; });
/* hero-card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/no-block-disable-of-nested-eslint */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $b2wEL = parcelRequire("b2wEL");
const $cd3457d7154b039d$export$57301f0520e516bf = ({ eyebrow: eyebrow, title: title, image: image, BackgroundImage: BackgroundImage, idx: idx, label: label })=>{
    const { openModal: openModal } = (0, $b2wEL.useHeroState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const handleClick = ()=>{
        openModal(idx);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: `atlas-55799-${label}-modal-opened`,
                section: "hero-section"
            }
        }).fire();
    };
    const eyebrowText = intl.locale === "en" ? eyebrow : "";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        onClick: handleClick,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _y3gn1e5h _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _2rkoqslr _c71l1kdj _1ul9gx0z _11q7cd5j _16qszucj _80omtlke _v564188d _1reozryt _18m9zryt _1i7qgx0z _5jif1dft _1ii31cd0 _hzy51qv5 _1lsjkb7n _c1lpkb7n _mlnj1xcn _1y8o122m _123rnklw"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bozg1u1b"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaz1hlo _ect41qje _1wyb1crf _k48p1nn1 _vwz47vkz _1dyz1wr8 _1p1dangw _1q511pa9 _3fcw1q9c _1bysw1gv _1rfmn6wy"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: eyebrowText
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bsbzdsj _syaz1hlo _ect41qje _1wyb1tcg _k48p1fw0 _vwz41ul9 _1q511v6z _slp31hna _ct361wug _1bah1yb4 _zzrmn6wy _1gdl1oqx _1p1d1tcg _1r3wgktf _ui901hlo _1jw8ni7l _1bys1f4h"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _18m9zryt _c71l1kdj"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)(BackgroundImage, {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_2rkoqslr _15801u1b _f45rstnw _dgw6idpf _1hlvidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: image,
                                width: 227,
                                height: 364,
                                alt: "",
                                loading: "eager"
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const $cd3457d7154b039d$var$cardStyles = null;
const $cd3457d7154b039d$var$textStyles = null;
const $cd3457d7154b039d$var$eyebrowStyles = null;
const $cd3457d7154b039d$var$titleStyles = null;
const $cd3457d7154b039d$var$imageContainer = null;
const $cd3457d7154b039d$var$pictureStyles = null;

});
parcelRegister("b2wEL", function(module, exports) {
$parcel$export(module.exports, "useHeroState", function () { return $2f6af509606af537$export$e2b31be5fe4d64c8; });
$parcel$export(module.exports, "HeroContextProvider", function () { return $2f6af509606af537$export$b1ebf81440d0ff8d; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $2f6af509606af537$var$initVal = {
    modalIndex: -1,
    closeModal: ()=>-1,
    openModal: ()=>0
};
const $2f6af509606af537$export$63ebd153bf781d5f = /*#__PURE__*/ (0, $1oC0p.createContext)($2f6af509606af537$var$initVal);
const $2f6af509606af537$export$e2b31be5fe4d64c8 = ()=>{
    return (0, $1oC0p.useContext)($2f6af509606af537$export$63ebd153bf781d5f);
};
const $2f6af509606af537$export$b1ebf81440d0ff8d = ({ children: children })=>{
    const [modalIndex, setModalIndex] = (0, $1oC0p.useState)(-1);
    const openModal = (num)=>setModalIndex(num);
    const closeModal = ()=>setModalIndex(-1);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($2f6af509606af537$export$63ebd153bf781d5f.Provider, {
        value: {
            modalIndex: modalIndex,
            openModal: openModal,
            closeModal: closeModal
        },
        children: children
    });
};

});


parcelRegister("6tzCE", function(module, exports) {
$parcel$export(module.exports, "OrangeCard", function () { return $ff9b5386d1e37ddf$export$b9f0637fcee76583; });
$parcel$export(module.exports, "PurpleCard", function () { return $ff9b5386d1e37ddf$export$265c26304bb77354; });
$parcel$export(module.exports, "GreenCard", function () { return $ff9b5386d1e37ddf$export$961a018b253e0f90; });
$parcel$export(module.exports, "BlueCard", function () { return $ff9b5386d1e37ddf$export$294f4b24111c26a1; });
$parcel$export(module.exports, "BlackCard", function () { return $ff9b5386d1e37ddf$export$89725581676ad6dc; });

var $7VQPk = parcelRequire("7VQPk");
const $ff9b5386d1e37ddf$export$b9f0637fcee76583 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 392",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190 10.1105L287 0.5V551.5H190V10.1105Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                y: "309.5",
                width: "72",
                height: "242",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12 174L242 93.5V551.5H33.7079L12 174Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M91.3757 345.607C94.4326 316.532 72.821 353.827 66.5766 359.591C66.6744 349.361 70.2219 339.822 71.6661 329.54C71.4521 329.774 71.4286 329.07 71.6094 328.451C73.7067 306.146 55.5882 335.822 52.852 342.965C52.8571 342.947 53.3076 341.612 53.3161 341.582C31.2979 381.303 52.5372 327.158 50.7712 312.8C48.0114 301.66 39.0231 319.691 36.7403 323.74C31.7817 332.292 13.1954 371.804 21.3158 339.578L21.2302 339.793L21.2235 339.686C19.9412 343.752 15.1863 361.553 23.3964 349.43C10.382 367.677 25.8305 321.339 26.8121 316.021C26.1187 322.416 23.5003 329.295 23.3121 331.581C41.6247 260.152 8.32378 331.528 -3.15113 344.753C-3.42866 340.861 -2.2046 336.52 -1.45501 332.791C-1.98174 333.871 -3.12206 341.129 -3.73261 342.354C-3.72327 338.625 1.46654 318.867 -0.581947 328.733C-0.457885 325.429 13.7951 290.239 0.489425 297.317C-9.28835 307.87 -13.5004 323.636 -23.888 333.64C-27.6163 327.225 -8.20945 290.969 -22.1535 295.019C-27.7263 298.074 -47.3766 333.181 -43.7036 312.264C-42.1393 303.197 -44.4527 311.487 -45.0251 315.266C-45.0595 314.841 -45.0769 314.422 -45.0925 313.996C-47.299 337.542 -24.8339 295.427 -19.3444 295.729C-19.8045 309.234 -37.4438 360.038 -12.0674 320.742C-12.162 320.968 -12.767 322.392 -12.8497 322.576C-9.19942 319.69 -2.36649 297.801 4.10625 299.033C4.95454 300.683 2.22361 313.34 3.286 305.572C-18.0291 379.053 3.4966 342.697 25.4581 304.882C28.5782 319.533 11.6245 341.427 18.0739 356.474C32.5546 349.034 35.4669 325.194 47.1207 313.346C48.9171 319.068 44.6492 329.85 43.4684 336.596L43.6763 336.143C36.233 364.657 39.9023 372.572 56.209 341.886C58.3648 338.768 71.6989 313.331 68.9071 329.746C59.4974 378.571 64.4338 364.369 88.6115 336.779C92.4748 337.752 87.4444 359.722 91.3626 345.61L91.3757 345.607Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$265c26304bb77354 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 391",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190 88.1977L287 80V550H190V88.1977Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                y: "245",
                width: "72",
                height: "305",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.5 0L261 16V550H35.5011L18.5 0Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.3957 245.058C33.5425 244.959 48.888 241.246 44.8628 240.44C43.3696 240.859 42.2092 240.436 41.4627 241.57C41.2468 240.233 38.3189 242.367 37.8691 242.448C37.6668 241.435 33.0793 244.041 33.7494 243.1C31.6671 243.127 29.081 243.856 26.3915 244.712C25.0737 243.816 30.7226 237.425 28.3479 238.807C28.5143 238.446 29.153 236.889 29.0675 237.92C29.8186 237.038 37.9951 223.535 34.595 225.822C32.3012 228.608 30.5787 233.275 28.6358 235.58C26.7468 236.358 25.438 243.046 23.3332 242.38C22.1054 240.877 18.9391 222.469 16.6904 224.103C17.0817 225.534 16.7264 226.816 17.8193 227.505C16.4835 227.721 18.6153 230.651 18.6963 231.101C17.7068 231.29 20.2704 235.899 19.3484 235.224C19.3664 236.525 19.6587 238.028 20.0815 239.626C19.5193 239.198 18.9032 238.221 18.5479 238.077C14.761 236.543 11.8915 233.014 7.94723 231.101C4.63257 235.327 33.9428 245.99 15.7684 247.583C12.3503 249.815 7.8078 250.157 3.99392 252.304C3.6656 256.954 25.4066 244.126 19.1325 251.494C18.1566 254.609 16.7084 258.106 14.707 261.175C13.4297 272.882 24.2912 241.079 23.8414 253.213C25.3391 256.112 26.7873 259.605 27.5294 263.201C32.8409 270.996 25.591 250.374 24.8309 247.453C27.7093 246.224 38.8361 260.158 40.851 257.962C40.9454 257.651 39.3443 255.927 38.8586 255.743C38.5303 255.909 38.3639 256.044 38.1705 255.738C39.1464 254.798 35.7238 253.61 35.4 253.286C36.1196 252.57 31.3568 250.243 32.5126 250.279C31.6221 249.032 30.2594 247.777 28.7077 246.512C31.4602 245.981 32.6565 244.036 32.4047 245.049L32.3957 245.058Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$961a018b253e0f90 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 409",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M75.9004 26.5L287.4 0.5V569H119.4L75.9004 26.5Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-5.59961 311L67.4004 286L72.4004 568.5H0.400391L-5.59961 311Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9.40039 151L242.4 110.5V568.5H34.1083L21.4004 352L9.40039 151Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.8986 132.781C39.2166 132.221 36.9442 123.743 35.8543 126.325C35.3391 127.211 35.4683 127.971 36.3627 128.134C34.6953 128.569 37.0904 129.969 36.6079 130.815C35.405 130.663 38.0687 132.76 36.8029 132.437C36.3425 141.913 49.4139 159.478 40.5422 137.288C40.2112 139.625 39.5574 137.525 39.7288 136.473C41.3639 137.777 39.6836 133.639 39.0942 132.906C39.2394 134.228 37.9371 132.161 38.895 132.785L38.8986 132.781Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.0831 151.179C25.9033 149.969 17.1793 145.733 16.3356 145.174C14.3049 144.321 14.3929 147.139 16.0855 147.422C16.3879 147.621 18.8106 148.168 17.851 148.841C18.5768 151.171 22.8129 151.064 23.2479 153.049C23.7743 152.669 24.4966 153.313 24.8533 153.111C24.8407 153.717 25.6701 153.967 25.7296 153.816C28.0241 156.156 30.1997 152.73 27.1018 151.667C27.2204 151.551 26.6349 150.91 26.0911 151.178L26.0831 151.179Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.214 183.803C14.6822 184.753 13.2253 184.829 12.5136 184.357C13.6609 183.246 10.784 183.546 10.075 183.952C10.379 183.982 10.4712 184.496 9.84193 184.471C10.3094 183.168 2.35086 182.948 6.04574 185.633C6.18193 185.627 6.26697 184.6 6.41885 184.919C6.11372 186.476 7.39131 185.384 7.74683 185.263C7.71942 186.071 8.07319 185.319 8.154 185.653C7.69634 186.742 9.77517 184.913 9.26035 185.992C11.045 187.634 14.7083 185.435 16.0664 186.932C17.0725 185.111 22.8461 187.798 20.677 184.338C18.1787 183.565 16.1276 183.133 13.214 183.803Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-1.49997 165.314C-2.19099 167.811 3.30413 167.242 4.76979 168.257C6.53807 169.708 25.7928 174.672 20.8767 169.788C15.0359 168.335 10.5165 166.116 3.19864 165.256C2.02145 165.029 -1.61684 163.57 -1.49997 165.314Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.4411 142.901C59.4435 144.317 56.8745 146.385 58.5173 147.732C61.6811 149.754 63.1253 131.281 59.8252 131.898C57.053 132.811 58.6706 141.577 57.4411 142.901Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$294f4b24111c26a1 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 399",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: "-0.199219",
                y: "280",
                width: "72",
                height: "278",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.8008 138.97L241.801 109V558H33.5086L11.8008 138.97Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M90.8008 21.5233L280.801 0.5L286.801 558H90.8008V21.5233Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M55.8008 315.386C53.0837 310.928 56.2763 303.048 51.8894 298.79C43.0193 295.942 41.3834 312.505 35.5983 314.656C32.9661 310.471 35.7511 304.135 32.4397 299.771C32.5982 299.877 33.1077 300.429 33.1643 300.501C24.464 290.96 21.5771 313.413 14.9939 314.74C12.2316 310.148 16.8959 297.698 8.42202 298.227C3.07847 298.305 -3.06324 320.558 -6.14824 312.979L-6.15955 313.085L-6.19918 313.046C-5.89917 318.446 -1.16129 312.449 -0.312218 310.755C-7.56903 324.119 -7.16713 307.244 -7.90866 301.114C-6.45956 302.736 -7.05958 307.188 -6.56711 309.106C-6.63504 285.705 -18.9581 306.263 -24.5846 314.506C-28.5753 314.305 -25.6828 304.787 -27.4545 301.66C-27.3526 302.329 -26.6847 306.113 -27.3413 306.849C-27.5168 304.079 -27.3583 298.222 -31.666 298.929C-31.2244 298.021 -29.0621 298.929 -28.813 299.347C-37.836 295.084 -39.0303 313.202 -46.089 314.79C-48.1438 310.075 -45.54 304.045 -48.4155 299.403C-56.7761 290.498 -65.867 327.608 -67.401 309.49C-67.8708 305.834 -66.5066 299.431 -71.1992 298.801C-70.4577 299.23 -68.7992 300.384 -68.8897 302.179C-69.0143 301.989 -69.1331 301.8 -69.2577 301.621C-67.984 306.397 -70.1294 311.513 -67.8595 316.01C-61.9669 321.533 -56.0403 297.86 -50.0684 300.228C-47.6117 303.293 -49.3722 308.353 -48.7495 312.02C-48.7948 311.903 -49.0212 311.145 -49.0608 311.045C-47.4249 328.622 -35.8887 303.388 -37.0152 307.149C-22.5185 284.546 -36.5567 329.725 -20.8487 314.974C-17.1467 311.914 -14.8711 300.172 -9.98608 301.738C-9.32946 307.79 -9.0068 325.211 0.0557327 313.943C3.46905 310.17 4.82756 302.151 9.87677 301.036C12.5542 305.767 8.05408 322.286 18.4412 316.936C18.3393 316.975 18.2431 317.019 18.1355 317.058C22.347 315.609 26.632 296.137 31.0472 302.006C32.751 305.818 29.5415 316.791 36.1077 317.119C41.8532 316.646 47.7289 292.587 51.7761 303.522C52.512 306.13 52.1837 317.654 55.7894 315.37L55.8008 315.386Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$89725581676ad6dc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 428",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.199 46.1105L287.199 36.5V587.5H190.199V46.1105Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: "0.199219",
                y: "345.5",
                width: "72",
                height: "242",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.1992 210L242.199 129.5V587.5H33.9071L12.1992 210Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M264.513 26.5943C264.532 26.5625 264.532 26.5053 264.57 26.4609C263.451 25.9017 263.323 24.5292 262.46 23.7096L262.428 23.6778C261.552 23.3982 261.789 22.5277 260.702 22.5213C260.702 22.5213 260.983 22.3815 260.99 22.3815C259.225 20.6405 254.864 16.3642 254.864 16.3642C254.768 16.7518 255.561 16.0782 256.36 16.1926C256.36 16.1926 256.418 16.0465 256.475 16.1609C258.515 14.1848 260.811 13.4286 263.419 12.4882C264.724 12.1387 264.922 8.47237 262.69 9.991C262.665 9.96558 262.607 9.94659 262.582 9.90211C261.802 10.8044 260.504 10.4739 259.519 10.9441L259.481 10.9632L257.844 11.7575C256.955 12.1196 255.9 12.4056 254.794 12.6852C254.826 12.6534 254.858 12.6217 254.89 12.5899C254.89 12.5899 255.005 10.8298 254.973 9.95927C254.973 9.95927 256.092 8.5614 255.721 7.60193C256.354 6.47725 258.605 4.01814 256.559 3.31919C255.887 3.31919 255.363 2.74099 255.133 3.81483C255.094 3.80848 255.043 3.82117 254.992 3.80211C254.871 4.91408 253.547 5.702 253.183 6.75678L253.17 6.8013C253.259 7.70359 252.556 8.59313 252.55 8.59313C252.217 9.41916 251.782 10.3214 251.322 11.2618C251.13 10.7535 250.919 10.3024 250.708 9.97836C249.941 9.15232 250.267 -2.13257 247.428 0.358238C247.563 2.48686 248.24 4.70441 247.69 6.59793C247.422 6.74407 247.831 7.50022 248.164 8.11657C248.138 8.89812 247.978 9.31751 247.933 10.4358C246.527 9.42553 240.389 4.3105 240.766 7.75442C241.424 8.1039 241.904 8.50418 242.249 9.3175C242.569 9.66698 245.389 11.2428 245.478 11.6368C245.293 12.1832 248.624 12.6216 247.275 13.0283C247.473 13.4604 247.742 13.8734 248.055 14.2737C246.597 14.4262 244.852 14.8519 243.937 15.4047C243.777 15.6779 237.959 16.0465 235.849 17.3999C234.589 18.1052 233.477 18.4547 234.788 19.5159C235.261 19.1346 237.038 19.6811 237 19.1791C237.435 19.357 240.376 18.2386 240.702 18.4293C240.862 18.6834 243.176 17.3364 242.901 17.9718C244.506 18.4229 246.463 18.0544 248.496 17.5397C247.69 18.8105 246.898 20.6214 246.795 21.7461C246.105 23.1885 244.282 26.3783 243.701 28.3354C242.869 29.7587 243.157 29.873 244.206 30.6037L244.225 30.6228C244.442 30.769 244.199 30.6228 245.024 30.6545C244.941 30.5783 244.82 30.2479 244.66 30.3051C244.768 30.0827 246.022 29.765 245.497 29.4663C245.478 29.4219 246.297 28.7992 246.38 28.1256C247.109 25.7238 248.854 24.5101 250.146 21.7715C250.114 22.0575 252.288 27.4394 252.185 30.1208C252.025 31.4425 255.248 33.4123 254.781 30.464C254.82 30.4513 254.851 30.4004 254.909 30.3941C254.391 29.1805 255.075 27.9286 254.807 26.696L254.794 26.6451C254.212 25.8954 254.883 25.2727 253.963 24.6627C253.963 24.6627 254.276 24.6944 254.282 24.7008C253.873 22.9534 253.617 20.8184 253.234 18.9058C254.609 20.1449 255.817 21.4792 256.316 22.947L256.38 22.8518C256.38 22.8962 256.475 22.928 256.392 23.0296C257.55 23.2711 257.946 23.754 258.784 24.0781C258.784 24.0781 259.679 25.6857 260.721 25.7428L262.307 27.9731C262.991 29.1232 266.68 28.4624 264.538 26.6197L264.513 26.5943Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("3FT2j", function(module, exports) {
$parcel$export(module.exports, "JswProductModalCarousel", function () { return $3148b6359fff8134$export$e7364013ca7b67b5; });
/* product-modal-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $3L8ZR = parcelRequire("3L8ZR");

var $lfTOg = parcelRequire("lfTOg");

var $gNuc8 = parcelRequire("gNuc8");

var $eMDDH = parcelRequire("eMDDH");

var $cB1fn = parcelRequire("cB1fn");

var $3yQG1 = parcelRequire("3yQG1");

var $6ED9p = parcelRequire("6ED9p");

var $g0VYP = parcelRequire("g0VYP");

var $2YpfC = parcelRequire("2YpfC");

var $5WMok = parcelRequire("5WMok");

var $dTWad = parcelRequire("dTWad");

var $bVodu = parcelRequire("bVodu");

var $l6HGO = parcelRequire("l6HGO");

var $04laP = parcelRequire("04laP");

var $kooLp = parcelRequire("kooLp");

var $6Ro48 = parcelRequire("6Ro48");

var $iNnWi = parcelRequire("iNnWi");

var $6RoNo = parcelRequire("6RoNo");

var $b97hj = parcelRequire("b97hj");

var $ktT4l = parcelRequire("ktT4l");

var $b2wEL = parcelRequire("b2wEL");
const $3148b6359fff8134$export$e7364013ca7b67b5 = ()=>{
    const { modalIndex: modalIndex } = (0, $b2wEL.useHeroState)();
    const intl = (0, $8e22h.default)();
    const itModalUpdate = (0, $3L8ZR.default).checkGate("it-copy-and-image-update");
    // Disable scroll if modal is open
    (0, $1oC0p.useEffect)(()=>{
        if (modalIndex !== -1) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
    }, [
        modalIndex
    ]);
    const softwareModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-software-development.eyebrow-text",
            defaultMessage: "product and issue tracking"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-software-development.title-text",
            defaultMessage: "Software Development"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-software-development.description-text",
            defaultMessage: "Plan, track, release and support world-class software. Jira is the single source of truth for your entire development lifecycle."
        }),
        image: (0, $iNnWi.getProductSoftwareDevelopmentModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gNuc8))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-analytics.icon-text",
                    defaultMessage: "Analytics"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTWad))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04laP))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-sprint-planning.icon-text",
                    defaultMessage: "Sprint planning"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0VYP))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-forms.icon-text",
                    defaultMessage: "Forms"
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.OrangeModal),
        ctaLink: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&jiraProductTourSignupType=software-development"),
        label: "software-development",
        personaData: {
            team: "Software Development",
            persona: "Software Development Generic"
        }
    };
    const marketingModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-marketing.eyebrow-text",
            defaultMessage: "plan and launch campaigns"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-marketing.title-text",
            defaultMessage: "Marketing"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-marketing.description-text",
            defaultMessage: "Make launching viral marketing campaigns a breeze. Break down complex campaigns into actionable steps, easily collect requests, and stay aligned with cross-functional teams."
        }),
        image: (0, $iNnWi.getProductMarketingModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6ED9p))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lfTOg))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-calendar-view.icon-text",
                    defaultMessage: "Calendar view"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0VYP))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-forms.icon-text",
                    defaultMessage: "Forms"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cB1fn))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-reporting.icon-text",
                    defaultMessage: "Reporting"
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.PurpleModal),
        ctaLink: (0, $kooLp.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $6Ro48.TemplateKey).CampaignManagement}`),
        label: "marketing",
        personaData: {
            team: "Marketing",
            persona: "Marketing Generic"
        }
    };
    const itModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.eyebrow-text",
            defaultMessage: "manage and track requests"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.title-text",
            defaultMessage: "IT support services"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.description-text",
            defaultMessage: "Easily build custom forms, track requests, and fully automate your intake process. Communicate progress and collaborate directly on requests with internal stakeholders in one place."
        }),
        image: (0, $iNnWi.getProductItModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3yQG1))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-resolve-incidents.icon-text",
                    defaultMessage: "Resolve incidents"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YpfC))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-help-desk.icon-text",
                    defaultMessage: "Help desk"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVodu))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-manage-requests.icon-text",
                    defaultMessage: "Manage requests"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eMDDH))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-reporting.icon-text",
                    defaultMessage: "Reporting"
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.GreenModal),
        ctaLink: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&jiraProductTourSignupType=it"),
        label: "it",
        personaData: {
            team: "IT Support",
            persona: "IT Support Generic"
        }
    };
    const updatedItModal = (0, $dPABA._)((0, $6ogO3._)({}, itModal), {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.updated-eyebrow-text",
            defaultMessage: "plan and track it projects"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.updated-description-text",
            defaultMessage: "Streamline IT projects and deliver reliable services to internal teams, from migration management to software deployment. Gain visibility across IT workflows to align technology projects to business goals."
        }),
        image: (0, $iNnWi.getUpdatedProductItModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTWad))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-resolve-incidents.updated-icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVodu))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-help-desk.updated-icon-text",
                    defaultMessage: "Intake requests"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5WMok))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-manage-requests.updated-icon-text",
                    defaultMessage: "Release management"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eMDDH))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-reporting.icon-text",
                    defaultMessage: "Reporting"
                })
            }
        ]
    });
    const designModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-design.eyebrow-text",
            defaultMessage: "build creative workflows"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-design.title-text",
            defaultMessage: "Design"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-design.description-text",
            defaultMessage: "Collaborate on, organize, and deliver creative requests with ease. Give real-time visibility into designs with Jira\u2019s Figma integration and accelerate approvals."
        }),
        image: (0, $iNnWi.getProductDesignModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6ED9p))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-task-planning.icon-text",
                    defaultMessage: "Task planning"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YpfC))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVodu))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-prioritization.icon-text",
                    defaultMessage: "Prioritization"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cB1fn))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-forms.icon-text",
                    defaultMessage: "Forms"
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.BlueModal),
        ctaLink: (0, $kooLp.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $6Ro48.TemplateKey).WebDesignProcess}`),
        label: "design",
        personaData: {
            team: "Design",
            persona: "Design Generic"
        }
    };
    const operationsModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-operations.eyebrow-text",
            defaultMessage: "create intake processes"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-operations.title-text",
            defaultMessage: "Operations"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-operations.description-text",
            defaultMessage: "Manage procurement, office, and new vendor requests, craft new operational processes, monitor operational risks and more. Keep your company running at maximum efficiency with Jira."
        }),
        image: (0, $iNnWi.getProductOperationsModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6ED9p))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-task-planning.icon-text",
                    defaultMessage: "Task planning"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTWad))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l6HGO))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-prioritization.icon-text",
                    defaultMessage: "Prioritization"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0VYP))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-forms.icon-text",
                    defaultMessage: "Forms"
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.BlackModal),
        ctaLink: (0, $kooLp.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $6Ro48.TemplateKey).SimplifiedProcessControl}`),
        label: "operations",
        personaData: {
            team: "Operations",
            persona: "Operations Generic"
        }
    };
    // @ts-ignore
    const finalItModal = itModalUpdate ? updatedItModal : itModal;
    const JswProductTourModalCards = [
        softwareModal,
        marketingModal,
        updatedItModal,
        designModal,
        operationsModal
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: modalIndex !== -1 && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b97hj.ProductModalCarousel), {
                    children: JswProductTourModalCards.map((props, idx)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ktT4l.ProductModalCard), (0, $6ogO3._)({}, props), idx);
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqsw1n9t _1e02idpf _152tidpf _rjxpidpf _u7coidpf _1e0c1txw _4cvr1h6o _1bah1h6o _11q71sgx _1pbyzo7u _je3oglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ktT4l.ProductModalCard), (0, $6ogO3._)({}, JswProductTourModalCards[modalIndex]))
                })
            ]
        })
    });
};
const $3148b6359fff8134$var$modalBackgroundStyles = null;

});
parcelRegister("3yQG1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88c1f65a7c2db6559a42eb4e9e9ef8e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $297d68901457057c$var$_react = $297d68901457057c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $297d68901457057c$var$_baseNew = $297d68901457057c$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $297d68901457057c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FlagFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: active feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $297d68901457057c$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $297d68901457057c$var$_react.default.createElement($297d68901457057c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 1.75A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2z" clip-rule="evenodd"/>`
    }, props));
$297d68901457057c$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $297d68901457057c$var$_default = module.exports.default = $297d68901457057c$var$FlagFilledIcon;

});

parcelRegister("g0VYP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecb53df8812f428ed0814030a719aff1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba899f0dcb8b83d9$var$_react = $ba899f0dcb8b83d9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ba899f0dcb8b83d9$var$_baseNew = $ba899f0dcb8b83d9$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ba899f0dcb8b83d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba899f0dcb8b83d9$var$MenuIcon = (props)=>/*#__PURE__*/ $ba899f0dcb8b83d9$var$_react.default.createElement($ba899f0dcb8b83d9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$ba899f0dcb8b83d9$var$MenuIcon.displayName = 'MenuIcon';
var $ba899f0dcb8b83d9$var$_default = module.exports.default = $ba899f0dcb8b83d9$var$MenuIcon;

});

parcelRegister("bVodu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17ddc348c6f916127485ad6ca25becea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ae7cd7e072e93b9$var$_react = $8ae7cd7e072e93b9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8ae7cd7e072e93b9$var$_baseNew = $8ae7cd7e072e93b9$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8ae7cd7e072e93b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ae7cd7e072e93b9$var$SendIcon = (props)=>/*#__PURE__*/ $8ae7cd7e072e93b9$var$_react.default.createElement($8ae7cd7e072e93b9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$8ae7cd7e072e93b9$var$SendIcon.displayName = 'SendIcon';
var $8ae7cd7e072e93b9$var$_default = module.exports.default = $8ae7cd7e072e93b9$var$SendIcon;

});

parcelRegister("04laP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9875595fe1109f3e22750943d295221a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00d0cc79bda24e44$var$_react = $00d0cc79bda24e44$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $00d0cc79bda24e44$var$_baseNew = $00d0cc79bda24e44$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $00d0cc79bda24e44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multiple tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00d0cc79bda24e44$var$TasksIcon = (props)=>/*#__PURE__*/ $00d0cc79bda24e44$var$_react.default.createElement($00d0cc79bda24e44$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm6.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L6 8.086z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$00d0cc79bda24e44$var$TasksIcon.displayName = 'TasksIcon';
var $00d0cc79bda24e44$var$_default = module.exports.default = $00d0cc79bda24e44$var$TasksIcon;

});

parcelRegister("6Ro48", function(module, exports) {
$parcel$export(module.exports, "TemplateKey", function () { return $3bde895dc42da213$export$21f5be7276c6a79d; });
var $3bde895dc42da213$export$21f5be7276c6a79d = /*#__PURE__*/ function(TemplateKey) {
    TemplateKey["SimplifiedBasic"] = "com.pyxis.greenhopper.jira:gh-simplified-basic";
    TemplateKey["Scrum"] = "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum";
    TemplateKey["Kanban"] = "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban";
    TemplateKey["WebDesignProcess"] = "com.atlassian.jira-core-project-templates:jira-work-management-web-design-process";
    TemplateKey["GoToMarket"] = "com.atlassian.jira-core-project-templates:jira-work-management-go-to-market";
    TemplateKey["SimplifiedProcessControl"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-process-control";
    TemplateKey["ProcessControlTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-process-control-team-managed";
    TemplateKey["SalesPipeline"] = "com.atlassian.jira-core-project-templates:jira-work-management-sales-pipeline";
    TemplateKey["SimplifiedProcurement"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-procurement";
    TemplateKey["EmployeeOnboarding"] = "com.atlassian.jira-core-project-templates:jira-work-management-employee-onboarding";
    TemplateKey["PersonalTaskPlanner"] = "com.atlassian.jira-core-project-templates:jira-work-management-personal-task-planner";
    TemplateKey["CampaignManagement"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management";
    TemplateKey["CampaignManagementTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed";
    TemplateKey["CampaignManagementV2TeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed-v2";
    TemplateKey["Recruitment"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-recruitment";
    TemplateKey["RecruitmentTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-recruitment-team-managed";
    TemplateKey["LeadTracking"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-lead-tracking";
    TemplateKey["LeadTrackingTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-lead-tracking-team-managed";
    TemplateKey["MonthEndClose"] = "com.atlassian.jira-core-project-templates:jira-work-management-month-end-close";
    TemplateKey["MonthEndCloseTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-month-end-close-team-managed";
    return TemplateKey;
}({});

});

parcelRegister("6RoNo", function(module, exports) {
$parcel$export(module.exports, "OrangeModal", function () { return $6ebf3ce23ce1ed11$export$6c8874c44e988ef8; });
$parcel$export(module.exports, "PurpleModal", function () { return $6ebf3ce23ce1ed11$export$fd3dd56b06272778; });
$parcel$export(module.exports, "GreenModal", function () { return $6ebf3ce23ce1ed11$export$4e38f8e127b6b98b; });
$parcel$export(module.exports, "BlueModal", function () { return $6ebf3ce23ce1ed11$export$f4813b8b24b3c6ba; });
$parcel$export(module.exports, "BlackModal", function () { return $6ebf3ce23ce1ed11$export$523a506d2ef0ae23; });

var $7VQPk = parcelRequire("7VQPk");
const $6ebf3ce23ce1ed11$export$6c8874c44e988ef8 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 757 491",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M356 15.3286L756.5 0.5L743 448H356V15.3286Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M43 232.398L388 184V470L52.2992 459.355L43 232.398Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M130.234 460.03C140.887 430.441 107.574 463.703 99.1998 468.074C101.862 457.404 108.184 448.371 112.355 438.004C112.058 438.192 112.208 437.45 112.563 436.851C120.461 414.086 92.9297 440.308 88.1073 447.052C88.1175 447.034 88.951 445.758 88.968 445.729C54.5977 481.419 91.7038 430.441 93.3267 414.961C93.0425 402.582 78.5587 419.05 75.0123 422.678C67.3702 430.305 36.8636 466.687 53.9276 435.147L53.7787 435.35L53.798 435.236C51.3589 439.146 41.6341 456.497 53.7788 446C34.7693 461.626 63.4948 417.275 65.9126 411.975C63.5461 418.477 58.9206 424.975 58.1411 427.315C96.3111 357.491 41.5077 423.285 25.4617 434.069C26.1251 429.926 28.5681 425.713 30.3316 422.012C29.4769 423.002 26.3986 430.288 25.4147 431.407C26.3559 427.511 37.0523 408.23 32.3143 418.001C33.277 414.579 57.8915 381.568 41.3467 385.439C27.8528 393.88 19.2388 409.247 5.2045 416.952C2.66538 409.255 33.2703 376.495 16.7724 377.032C9.82032 378.748 -20.7683 410.243 -11.4671 389.347C-7.46621 380.282 -12.1051 388.336 -13.6843 392.136C-13.6164 391.682 -13.531 391.239 -13.4422 390.79C-21.7707 414.823 13.6935 376.748 19.715 378.519C15.8326 392.517 -16.441 440.957 21.5529 406.601C21.3914 406.812 20.3641 408.14 20.2264 408.31C25.0007 406.262 38.054 385.188 44.9353 388.193C45.4657 390.142 39.2729 402.652 42.3922 394.811C0.374836 465.986 33.3582 433.682 67.1895 399.97C66.9974 416.115 42.7024 434.51 46.1091 451.952C64.0492 448.014 73.2351 423.861 89.1359 414.564C89.7026 421.023 82.271 431.164 79.2755 437.904L79.6195 437.485C64.2344 465.324 66.334 474.572 92.1053 446.813C95.2779 444.125 116.437 421.066 109.239 437.488C86.5994 486.04 95.6274 472.501 129.368 450.066C133.416 452.108 122.344 473.745 130.219 460.029L130.234 460.03Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$fd3dd56b06272778 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 729 447",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M453 6.8593L729 0V325H453V6.8593Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21 229.336L218 185V447L26.31 437.248L21 229.336Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.471 195.058C29.6205 194.959 45.0014 191.246 40.9669 190.44C39.4702 190.859 38.3072 190.436 37.5589 191.57C37.3425 190.233 34.4079 192.367 33.9571 192.448C33.7542 191.435 29.1562 194.041 29.8279 193.1C27.7407 193.127 25.1487 193.856 22.453 194.712C21.1322 193.816 26.7941 187.425 24.4139 188.807C24.5807 188.446 25.2208 186.889 25.1352 187.92C25.888 187.038 34.0833 173.535 30.6754 175.822C28.3763 178.608 26.6498 183.275 24.7024 185.58C22.8091 186.358 21.4973 193.046 19.3876 192.38C18.1569 190.877 14.9834 172.469 12.7295 174.103C13.1216 175.534 12.7655 176.816 13.8609 177.505C12.5221 177.721 14.6588 180.651 14.74 181.101C13.7482 181.29 16.3177 185.899 15.3936 185.224C15.4117 186.525 15.7047 188.028 16.1284 189.626C15.5649 189.198 14.9473 188.221 14.5912 188.077C10.7956 186.543 7.91954 183.014 3.96613 181.101C0.643816 185.327 30.0217 195.99 11.8053 197.583C8.37936 199.815 3.82638 200.157 0.0036926 202.304C-0.325383 206.954 21.4657 194.126 15.1772 201.494C14.199 204.609 12.7475 208.106 10.7415 211.175C9.46124 222.882 20.3478 191.079 19.897 203.213C21.3981 206.112 22.8497 209.605 23.5935 213.201C28.9173 220.996 21.6506 200.374 20.8887 197.453C23.7738 196.224 34.9263 210.158 36.9458 207.962C37.0405 207.651 35.4357 205.927 34.9488 205.743C34.6198 205.909 34.453 206.044 34.2591 205.738C35.2373 204.798 31.8068 203.61 31.4823 203.286C32.2035 202.57 27.4297 200.243 28.5882 200.279C27.6956 199.032 26.3298 197.777 24.7745 196.512C27.5334 195.981 28.7325 194.036 28.48 195.049L28.471 195.058Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$4e38f8e127b6b98b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 740 478",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M739.945 477.053L728.47 42.8846L403.714 51.9593L402.956 475.471L739.945 477.053Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.2766 21.5979C66.7767 20.978 65.6542 10.1027 63.8098 13.042C63.0037 14.0204 63.013 14.9796 64.0782 15.3669C61.9471 15.5508 64.6106 17.7697 63.8524 18.7063C62.4064 18.268 65.2624 21.3987 63.7729 20.7378C61.3465 32.2642 73.9329 56.5486 67.4076 27.4713C66.5426 30.2678 66.1529 27.5553 66.5698 26.3008C68.3198 28.2426 67.071 22.8154 66.4921 21.7923C66.4105 23.4442 65.2187 20.6369 66.2713 21.6025L66.2766 21.5979Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M46.9395 41.4791C46.9566 39.9576 37.0855 32.9328 36.1601 32.0708C33.8362 30.599 33.3907 34.0732 35.4116 34.7754C35.7436 35.0826 38.6085 36.2619 37.299 36.8864C37.7317 39.8964 42.95 40.6524 43.0937 43.1784C43.8141 42.8232 44.5739 43.7637 45.051 43.5916C44.9167 44.3313 45.8852 44.8118 45.9878 44.6391C48.3432 47.9902 51.6853 44.2447 48.0933 42.2918C48.2618 42.1735 47.6694 41.2644 46.9494 41.4798L46.9395 41.4791Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24.7401 78.7976C26.3547 80.2709 24.5525 80.0579 23.772 79.3305C25.3978 78.2085 21.8092 77.9733 20.8595 78.3227C21.2268 78.4227 21.2389 79.0726 20.4717 78.9103C21.3013 77.4094 11.5803 75.4721 15.5859 79.54C15.7542 79.5615 16.0603 78.3193 16.184 78.7421C15.5038 80.5878 17.2858 79.5164 17.7456 79.443C17.5533 80.4283 18.1351 79.5794 18.1687 80.006C17.3932 81.2461 20.303 79.438 19.4595 80.6534C21.3263 83.0425 26.2528 81.1126 27.625 83.2332C29.2172 81.2103 35.7726 85.7171 33.7911 81.0187C30.8779 79.5466 28.4464 78.5866 24.7401 78.7976Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.3204 53.0348C8.98192 55.9537 15.8356 56.4071 17.4345 57.9592C19.3188 60.1099 41.9669 70.2344 36.895 63.213C30.0144 60.2067 24.9055 56.5376 16.0964 53.9487C14.6967 53.4237 10.5196 50.8717 10.3204 53.0348Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M87.0372 37.8984C89.2159 40.0542 85.6577 42.0527 87.4086 44.0495C90.893 47.1931 96.2939 24.8368 92.1239 24.9014C88.5433 25.4405 88.8059 36.5316 87.0372 37.8984Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$f4813b8b24b3c6ba = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 748 441",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 203.398L355 155V441L9.56873 430.355L0 203.398Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M748 21.7328C744.748 16.1599 748.569 6.30979 743.319 0.987671C732.702 -2.57202 730.745 18.1313 723.821 20.8202C720.67 15.5886 724.004 7.66819 720.04 2.21372C720.23 2.34607 720.84 3.03576 720.907 3.12632C710.495 -8.79968 707.039 19.2669 699.16 20.9248C695.854 15.1847 701.437 -0.377695 691.295 0.284086C684.899 0.381612 677.549 28.1973 673.856 18.7234L673.843 18.8559L673.795 18.8071C674.154 25.5572 679.825 18.0616 680.841 15.9439C672.156 32.6487 672.637 11.5552 671.749 3.89249C673.484 5.91963 672.766 11.4856 673.355 13.882C673.274 -15.3688 658.525 10.3292 651.791 20.6321C647.014 20.3813 650.476 8.48332 648.356 4.57533C648.478 5.41126 649.277 10.1411 648.491 11.0607C648.281 7.59849 648.471 0.277127 643.315 1.16182C643.844 0.0263465 646.432 1.16182 646.73 1.68428C635.931 -3.6448 634.501 19.002 626.053 20.9874C623.594 15.094 626.71 7.55679 623.269 1.75401C613.262 -9.37785 602.382 37.0094 600.546 14.3626C599.984 9.79281 601.616 1.78879 596 1.00162C596.888 1.53801 598.873 2.98004 598.764 5.22313C598.615 4.98628 598.473 4.74943 598.324 4.52652C599.848 10.4965 597.28 16.8914 599.997 22.5131C607.05 29.4165 614.143 -0.175617 621.29 2.78498C624.231 6.61635 622.124 12.9415 622.869 17.5252C622.815 17.3789 622.544 16.4316 622.496 16.3062C624.454 38.2773 638.261 6.73472 636.913 11.4369C654.264 -16.8177 637.462 39.6566 656.262 21.2173C660.693 17.3929 663.416 2.7153 669.263 4.67278C670.049 12.238 670.435 34.014 681.282 19.9285C685.367 15.2124 686.993 5.18826 693.036 3.79504C696.24 9.70927 690.854 30.3569 703.286 23.6694C703.164 23.7182 703.049 23.7739 702.92 23.8226C707.961 22.0114 713.089 -2.32819 718.374 5.00714C720.413 9.77196 716.572 23.4883 724.43 23.8993C731.307 23.3072 738.339 -6.76563 743.183 6.9019C744.064 10.162 743.671 24.568 747.986 21.7119L748 21.7328Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$523a506d2ef0ae23 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 721 465",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M359.416 94.2542L274.408 67.7112L9.74577 90.2379L0.164061 457.629L312.003 464.667L359.416 94.2542Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M720.092 34.905C720.117 34.8633 720.117 34.7882 720.168 34.7299C718.688 33.996 718.519 32.1946 717.377 31.1188L717.335 31.0771C716.177 30.7101 716.489 29.5676 715.052 29.5593C715.052 29.5593 715.424 29.3757 715.432 29.3757C713.098 27.0906 707.331 21.478 707.331 21.478C707.204 21.9867 708.253 21.1027 709.31 21.2528C709.31 21.2528 709.386 21.061 709.462 21.2112C712.16 18.6175 715.196 17.625 718.646 16.3908C720.371 15.9321 720.633 11.12 717.682 13.1132C717.648 13.0798 717.572 13.0549 717.538 12.9965C716.506 14.1808 714.79 13.747 713.487 14.3641L713.437 14.3892L711.272 15.4317C710.096 15.907 708.701 16.2824 707.238 16.6493C707.28 16.6076 707.323 16.5659 707.365 16.5242C707.365 16.5242 707.517 14.2141 707.475 13.0715C707.475 13.0715 708.955 11.2368 708.464 9.97753C709.302 8.50139 712.278 5.27381 709.572 4.35644C708.684 4.35644 707.991 3.59755 707.686 5.00697C707.636 4.99863 707.568 5.01529 707.5 4.99027C707.34 6.44973 705.589 7.48388 705.107 8.86828L705.09 8.92671C705.209 10.111 704.279 11.2785 704.27 11.2785C703.83 12.3626 703.255 13.5469 702.646 14.7811C702.393 14.114 702.114 13.5219 701.835 13.0966C700.82 12.0124 701.251 -2.799 697.497 0.470187C697.674 3.26401 698.57 6.17454 697.843 8.65978C697.488 8.8516 698.029 9.84404 698.469 10.653C698.435 11.6788 698.224 12.2292 698.165 13.697C696.304 12.371 688.186 5.65753 688.685 10.1777C689.556 10.6364 690.19 11.1617 690.647 12.2292C691.07 12.6879 694.799 14.7562 694.917 15.2733C694.672 15.9905 699.078 16.5659 697.294 17.0996C697.556 17.6667 697.911 18.2089 698.325 18.7343C696.397 18.9344 694.089 19.4931 692.879 20.2187C692.668 20.5773 684.973 21.061 682.182 22.8374C680.516 23.7631 679.045 24.2218 680.778 25.6146C681.404 25.1142 683.755 25.8314 683.704 25.1725C684.279 25.4061 688.169 23.9382 688.6 24.1884C688.812 24.522 691.873 22.754 691.509 23.588C693.632 24.1801 696.22 23.6963 698.909 23.0208C697.843 24.6888 696.795 27.0656 696.659 28.5417C695.746 30.4349 693.336 34.6215 692.566 37.1902C691.467 39.0583 691.848 39.2083 693.235 40.1674L693.26 40.1925C693.547 40.3843 693.226 40.1924 694.317 40.2341C694.207 40.134 694.046 39.7004 693.835 39.7755C693.979 39.4836 695.636 39.0665 694.943 38.6746C694.917 38.6162 696 37.7989 696.11 36.9149C697.074 33.7625 699.382 32.1696 701.09 28.5751C701.048 28.9504 703.923 36.0142 703.788 39.5336C703.577 41.2682 707.839 43.8536 707.221 39.984C707.272 39.9673 707.314 39.9006 707.39 39.8922C706.705 38.2993 707.61 36.6564 707.255 35.0384L707.238 34.9718C706.469 33.9877 707.357 33.1704 706.139 32.3698C706.139 32.3698 706.553 32.4114 706.562 32.4197C706.02 30.1263 705.682 27.3242 705.175 24.8139C706.993 26.4401 708.591 28.1915 709.251 30.118L709.335 29.9929C709.335 30.0513 709.462 30.0929 709.352 30.2264C710.883 30.5433 711.407 31.1771 712.515 31.6025C712.515 31.6025 713.699 33.7124 715.077 33.7875L717.174 36.7147C718.079 38.2242 722.959 37.3569 720.126 34.9384L720.092 34.905Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("b97hj", function(module, exports) {
$parcel$export(module.exports, "ProductModalCarousel", function () { return $67177947439a6edd$export$4bbc33d47571e3e6; });
/* modal-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $ggSCt = parcelRequire("ggSCt");

var $eY3N6 = parcelRequire("eY3N6");

var $b2wEL = parcelRequire("b2wEL");
const $67177947439a6edd$var$LeftArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: onClick,
        className: (0, $2jatx.default)([
            "_kqswstnw _19itglyw _80omtlke _1pbykb7n _bfhk1j28 _152t1ssb _1e0216lh"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "65",
            height: "64",
            viewBox: "0 0 65 64",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M56.6172 32C56.6172 18.6667 45.9505 8 32.6172 8C19.2838 8 8.61718 18.6667 8.61719 32C8.61719 45.3333 19.2839 56 32.6172 56C45.9505 56 56.6172 45.3333 56.6172 32Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M35.2842 20.2667L39.0176 24.0001L31.0176 32.0001L39.0176 40.0001L35.2842 43.7334L23.5509 32.0001L35.2842 20.2667Z",
                    fill: "white"
                })
            ]
        })
    });
const $67177947439a6edd$var$RightArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: onClick,
        className: (0, $2jatx.default)([
            "_kqswstnw _19itglyw _80omtlke _1pbykb7n _bfhk1j28 _152t1ssb _rjxp16lh"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "64",
            height: "64",
            viewBox: "0 0 64 64",
            fill: "#none",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M8 32C8 45.3333 18.6667 56 32 56C45.3333 56 56 45.3333 56 32C56 18.6667 45.3333 8 32 8C18.6667 8 8 18.6667 8 32Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M29.3329 43.7333L25.5996 39.9999L33.5996 31.9999L25.5996 23.9999L29.3329 20.2666L41.0663 31.9999L29.3329 43.7333Z",
                    fill: "white"
                })
            ]
        })
    });
const $67177947439a6edd$var$settings = {
    prevArrow: /*#__PURE__*/ (0, $7VQPk.jsx)($67177947439a6edd$var$LeftArrow, {}),
    nextArrow: /*#__PURE__*/ (0, $7VQPk.jsx)($67177947439a6edd$var$RightArrow, {})
};
const $67177947439a6edd$export$4bbc33d47571e3e6 = ({ children: children })=>{
    const { modalIndex: modalIndex } = (0, $b2wEL.useHeroState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const beforeChange = (currentSlide, nextSlide)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-carousel-slide-button-clicked",
                section: "hero-section",
                slide: currentSlide,
                nextSlide: nextSlide
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1e02idpf _152tidpf _rjxpidpf _u7coidpf _1e0c1txw _4cvr1h6o _1bah1h6o _11q71sgx _1pbyzo7u _liwcglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_j6fg1txw _19moidpf _1vqqkfja _m8oxidpf _bzd2kfja _3otn1r31 _1d59glyw _r3kx1o36 _1u351txw _6aywidpf _1imc1wqb _1plyidpf _1k001wqb _1xnx1ule _qzmo15vq",
                "_1bsb1w8u"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), (0, $dPABA._)((0, $6ogO3._)({}, $67177947439a6edd$var$settings), {
                initialSlide: modalIndex,
                beforeChange: beforeChange,
                children: children
            }))
        })
    });
};
const $67177947439a6edd$var$modalBackgroundStyles = null;
const $67177947439a6edd$var$sliderParent = null;
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $67177947439a6edd$var$slickStyle = null;
const $67177947439a6edd$var$arrowButton = null;
const $67177947439a6edd$var$buttonLeft = null;
const $67177947439a6edd$var$buttonRight = null;

});

parcelRegister("ktT4l", function(module, exports) {
$parcel$export(module.exports, "ProductModalCard", function () { return $9d005f3db5353a9a$export$91f997500fc720d5; });
/* product-modal-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $h6Fsc = parcelRequire("h6Fsc");

var $5qUgh = parcelRequire("5qUgh");

var $jmley = parcelRequire("jmley");

var $28AH4 = parcelRequire("28AH4");

var $b2wEL = parcelRequire("b2wEL");
const $9d005f3db5353a9a$export$91f997500fc720d5 = ({ eyebrow: eyebrow, title: title, description: description, iconCollection: iconCollection, image: image, BackgroundImage: BackgroundImage, ctaLink: ctaLink, label: label, personaData: personaData })=>{
    const intl = (0, $8e22h.default)();
    const { closeModal: closeModal } = (0, $b2wEL.useHeroState)();
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    const handleClick = ()=>{
        // Set team/persona in local storage for various uses later in funnel
        setAnchorLocalStorage(personaData);
    };
    const buttonText = intl.formatMessage({
        id: "jira-product-tour.hero-modal-cta-btn.btn-text",
        defaultMessage: "Get started"
    });
    const iconTitle = intl.formatMessage({
        id: "jira-product-tour.hero-modal-icon-title.title-text",
        defaultMessage: "Collaborate with these features"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2rkoqslr _11q71q2x _16qsaa27 _1bahesu3 _1bsb1w8u _4t3i1w8u _1ikw1us8 _6ru51osq _79ty1sxn _1p9vu67f _tnru1vuk _1rfm1w8u"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_16jlkb7n _kqswh2mm _1e0c11p5 _6a6z1h6o _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1vuk _1bsb1vuk _kqswstnw _1e0c1txw _1bah1h6o _1rfm1vuk _tnru1vuk"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)(BackgroundImage, {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: image,
                        alt: "",
                        className: (0, $2jatx.default)([
                            "_c71l1w8u _p12f12it _kqswstnw _1rkb1w8u _123r1w8u"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsbr60k _2rkoqslr _bfhku67f _zzrm1osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_ca0qidpf _u5f3d6z3 _n3tdidpf _19bvd6z3"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            onClick: closeModal,
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bahesu3 _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _19itglyw _1pfh7vkz _80omtlke"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))), {
                                size: "medium",
                                label: "Close"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_syaz1x0p _ect41qje _1wybdlk8 _k48p1nn1 _vwz4f6fq _1dyzt94y _1p1dangw _1q511skh _1cqs1crf _1bys7vkz"
                            ]),
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_syaz1x0p _ect41qje _1wybzwfg _k48p1fw0 _vwz410mc _1pfh14y2 _1cqs1tcg _1bysvpzd"
                            ]),
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfh1gkc _1cqs7vkz _1bys1tcg _srwz7vkz"
                            ]),
                            children: description
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3it94y _bfhk1sas _1pfhzwfg",
                                "_liwcglyw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfhzwfg _6rthrdoj _syazr3uz _1wyb7vkz _k48p1nn1 _vwz41tcg _1bsbn8ye",
                                "_liwcglyw"
                            ]),
                            children: iconTitle
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c116y _2lx21bp4 _4cvr1y6m _zulpftgi _81641y44"
                            ]),
                            children: iconCollection.map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o"
                                            ]),
                                            children: icon.icon
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_syazr3uz _1wybdlk8 _k48p1nn1 _vwz4gktf"
                                            ]),
                                            children: icon.description
                                        })
                                    ]
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1q51zwfg _1u2q7vkz _xlt17vkz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jmley.default), {
                                intentType: "button",
                                containerId: "jira-product-tour-overview-hero-modal-" + personaData.team,
                                productKey: "jira-software.ondemand",
                                edition: "free",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                    onClick: handleClick,
                                    href: ctaLink,
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    dataEventProps: {
                                        "data-product-key": "jira",
                                        "data-event": "clicked",
                                        "data-event-component": "button",
                                        "data-event-container": "heroSection",
                                        "data-label": "get-started",
                                        "data-label-english": "Get Started",
                                        "data-track-event": `jira-pt.hero-modal-${label}.get-started`
                                    },
                                    children: buttonText
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $9d005f3db5353a9a$var$modalStyles = null;
const $9d005f3db5353a9a$var$modalImageStyles = null;
const $9d005f3db5353a9a$var$imageStyles = null;
const $9d005f3db5353a9a$var$backgroundStyles = null;
const $9d005f3db5353a9a$var$modalContentStyles = null;
const $9d005f3db5353a9a$var$textSpaceStyles = null;
const $9d005f3db5353a9a$var$closeModalButtonStyles = null;
const $9d005f3db5353a9a$var$eyebrowStyles = null;
const $9d005f3db5353a9a$var$titleStyles = null;
const $9d005f3db5353a9a$var$descriptionStyles = null;
const $9d005f3db5353a9a$var$seporatorStyles = null;
const $9d005f3db5353a9a$var$iconTitleStyles = null;
const $9d005f3db5353a9a$var$iconDescriptionStyles = null;
const $9d005f3db5353a9a$var$iconContainerStyles = null;
const $9d005f3db5353a9a$var$iconAndTextStyles = null;
const $9d005f3db5353a9a$var$iconStyles = null;
const $9d005f3db5353a9a$var$buttonSpaceStyles = null;
const $9d005f3db5353a9a$var$displayNoneBelowLg = null;

});





parcelRegister("dS67T", function(module, exports) {
$parcel$export(module.exports, "JswDoubleFeatureSection", function () { return $8f8dac8bd8ab28d3$export$fa980c3455a6cd08; });
/* jsw-double-feature.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("7P5uc");
var $7asA7 = parcelRequire("7asA7");

var $ahPqL = parcelRequire("ahPqL");
const $8f8dac8bd8ab28d3$export$fa980c3455a6cd08 = ()=>{
    const intl = (0, $8e22h.default)();
    const doubleFeatureItems = [
        {
            title: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.first-card-title-text",
                defaultMessage: "Easily see every team\u2019s progress"
            }),
            description: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.first-card-description-text",
                defaultMessage: "Track every team\u2019s work in a single timeline. Understand progress, map dependencies, and stay ahead of risks."
            }),
            image: (0, $ahPqL.getDoubleFeatureFirstImage)(intl.locale)
        },
        {
            title: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.second-card-title-text",
                defaultMessage: "Map work to company impact"
            }),
            description: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.second-card-description-text",
                defaultMessage: "With goals in Jira, it\u2019s easy to track all the tasks across projects that contribute to a goal, no matter what team is working on it."
            }),
            image: (0, $ahPqL.getDoubleFeatureSecondImage)(intl.locale)
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _1eog16gx _qjx3idpf _1celidpf _5n7aidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_syaz1hlo _y3gn1h6o _ect41pz4 _1wyb1ylp _k48p1fw0 _vwz4ckbl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r3w1ul9 _1eogidpf _qjx310yn _1celidpf _5n7a10yn"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                },
                children: intl.formatMessage({
                    id: "jira-product-tour.double-feature-section.title-text",
                    defaultMessage: "Never lose sight of the big picture"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _zulp1ul9 _ca0q1u1b _u5f3idpf _n3td10yn _19bvidpf _79ty1bp4 _1np61h6o _1yytzwfg _1eog1u1b _qjx39by0 _1cel10yn _5n7a9by0"
                ]),
                children: doubleFeatureItems.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7asA7.JswDoubleFeatureCard), {
                        title: item.title,
                        description: item.description,
                        image: item.image
                    }, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_mkrzzwj5 _bfhkr3uz _4t3ir0r7 _1pby1mrw _1pfh1o8r"
                ])
            })
        ]
    });
};
$8f8dac8bd8ab28d3$export$fa980c3455a6cd08.displayName = "JswDoubleFeatureSection";
const $8f8dac8bd8ab28d3$var$containerStyles = null;
const $8f8dac8bd8ab28d3$var$titleStyles = null;
const $8f8dac8bd8ab28d3$var$cardContainerStyles = null;
const $8f8dac8bd8ab28d3$var$blackShapeStyles = null;

});

parcelRegister("1i0Tw", function(module, exports) {
$parcel$export(module.exports, "NoJiraHeroSection", function () { return $5f71690abca8e56f$export$68338f1ab5428abb; });
/* no-jira-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("7P5uc");
var $6Sktx = parcelRequire("6Sktx");
var $7chqp = parcelRequire("7chqp");
var $6V1n4 = parcelRequire("6V1n4");
const $5f71690abca8e56f$export$68338f1ab5428abb = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "logged-out-no-jira-product-tour-hero",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk1hxd _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Sktx.Header), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7chqp.HeroCards), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6V1n4.LogoBanner), {})
        ]
    });
};
$5f71690abca8e56f$export$68338f1ab5428abb.displayName = "NoJiraHeroSection";
const $5f71690abca8e56f$var$heroStyles = null;

});

parcelRegister("6PlQY", function(module, exports) {
$parcel$export(module.exports, "TestimonialSection", function () { return $f83d961845a629ac$export$1b0efcc7c1027c88; });
/* testimonial.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("7P5uc");
var $AR1pQ = parcelRequire("AR1pQ");

var $ahPqL = parcelRequire("ahPqL");
const $f83d961845a629ac$export$f756e64b0cdd0c57 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_mezj1u1b _bna710mc _1egfglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3t76qr31nd0pyj71cs0562wxs6agxl02.webp",
                alt: ""
            }
        })
    });
};
const $f83d961845a629ac$export$1b0efcc7c1027c88 = ()=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const useGWP7617Gate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-testimonial-button-clicked",
                section: "testimonial-section"
            }
        }).fire();
    };
    const header = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.header-text",
        defaultMessage: "For teams big & small"
    });
    const subtitle = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.subtitle-text",
        defaultMessage: "Hear from start-ups & large enterprises that prefer Atlassian"
    });
    const ctaTextOld = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.cta-text",
        defaultMessage: "See more customer stories"
    });
    const ctaTextAi = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.cta-text-ai",
        defaultMessage: "See how Roblox boosts collaboration with AI"
    });
    const ctaText = useGWP7617Gate ? ctaTextAi : ctaTextOld;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_mkrz16pp _11q71hlo _1e0c1txw _4cvr1h6o _1bah1h6o _ca0q19bv _u5f3idpf _n3td53f4 _19bvidpf _2tde53f4 _1a87idpf _uwpc53f4 _3r7oidpf _1kmx19bv _1ggmidpf _1ykzuuw1 _1maeidpf"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _4cvr1y6m _a64k1w81 _79ty1bp4 _1np61h6o _1yytidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1y6m _zulp19bv"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($f83d961845a629ac$export$f756e64b0cdd0c57, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_liwc1txw _79ty1bp4 _105s1h6o _1rkb1i94 _1kmxidpf _1ggm10yn _1ykzidpf _1mae10yn"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1i7q1ogy _liwc1txw _79ty1bp4 _m80d1h6o _1yyt10yn _1p1d8vuz _1rkbjwe6"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_syazcd5j _ect41pz4 _k48p1fw0 _vwz44jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _fz891ylp _1ol9ckbl _flz0ckbl _1lzo1ylp _1cqs1ul9"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                        },
                                        children: header
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1pfh1y44 _syaz1f62 _ect4bzd7 _1wyb7vkz _k48p1nn1 _vwz41tcg"
                                        ]),
                                        style: {
                                            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        },
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1pfhzwfg _1rwyidpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                            href: (0, $kooLp.useLocalizedHref)("/customers/roblox"),
                                            onClick: handleClick,
                                            className: (0, $2jatx.default)([
                                                "_syazcqtm"
                                            ]),
                                            style: {
                                                "--_r4erkq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue400"))
                                            },
                                            children: [
                                                ctaText,
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahPqL.ArrowRight), {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $AR1pQ.TestimonialCard), {
                    image: "https://dam-cdn.atl.orangelogic.com/AssetLink/thb1c563p4m28u32ri7fe867jx24dxpl.webp",
                    quote: intl.formatMessage({
                        id: "jira-product-tour.testimonial-section.quote-text",
                        defaultMessage: "Before, our team saw Atlassian as individual tools...Now, [features & integrations] like Jira macros & Smart Links have really been pivotal in collaboration, productivity, & discoverability."
                    }),
                    name: intl.formatMessage({
                        id: "jira-product-tour.testimonial-section.name-text",
                        defaultMessage: "Joe Cotant"
                    }),
                    title: intl.formatMessage({
                        id: "jira-product-tour.testimonial-section.job-title-text",
                        defaultMessage: "Senior Technical Program Manager, Roblox"
                    })
                })
            ]
        })
    });
};
$f83d961845a629ac$export$1b0efcc7c1027c88.displayName = "TestimonialSection";
const $f83d961845a629ac$var$sectionContainer = null;
const $f83d961845a629ac$var$testimonialContainer = null;
const $f83d961845a629ac$var$testimonialContentContainer = null;
const $f83d961845a629ac$var$leftContainer = null;
const $f83d961845a629ac$var$contentStyles = null;
const $f83d961845a629ac$var$headingStyles = null;
const $f83d961845a629ac$var$subtitleStyles = null;
const $f83d961845a629ac$var$linkStyles = null;
const $f83d961845a629ac$var$anchorStyles = null;
const $f83d961845a629ac$var$starStyles = null;

});


parcelRegister("iFk4q", function(module, exports) {
$parcel$export(module.exports, "Footer", function () { return $f4806120b6b5d670$export$a06f1c675e846f6f; });

var $7VQPk = parcelRequire("7VQPk");

var $8LaTa = parcelRequire("8LaTa");
const $f4806120b6b5d670$export$a06f1c675e846f6f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
    });
};
$f4806120b6b5d670$export$a06f1c675e846f6f.displayName = "Footer";

});

parcelRegister("1UnBI", function(module, exports) {
$parcel$export(module.exports, "LoggedOutHeroSection", function () { return $98430ad0795e6e5c$export$a8760ddc663c337c; });
/* logged-out-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2emUn = parcelRequire("2emUn");
parcelRequire("7P5uc");
var $7chqp = parcelRequire("7chqp");
var $6V1n4 = parcelRequire("6V1n4");

var $iE2db = parcelRequire("iE2db");

var $dmP4q = parcelRequire("dmP4q");
const $98430ad0795e6e5c$export$a8760ddc663c337c = ()=>{
    const intl = (0, $8e22h.default)();
    const headerContent = {
        mainHeadingFirstPart: intl.formatMessage({
            id: "jira-product-tour.hero-header.first-header-text",
            defaultMessage: "Great outcomes"
        }),
        mainHeadingSecondPart: intl.formatMessage({
            id: "jira-product-tour.hero-header.second-header-text",
            defaultMessage: "start with Jira"
        }),
        subHeading: intl.formatMessage({
            id: "jira-product-tour.hero-header.sub-header-text",
            defaultMessage: "The only project management tool you need to plan and track work across every team."
        }),
        buttonText: intl.formatMessage({
            id: "jira-product-tour.hero-header.button-text",
            defaultMessage: "Get Jira free"
        })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2emUn.FeatureExposed), {
        experimentKey: "jfind-jpto-organic-optimize-embedded-signup",
        group: "Test",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk1hxd _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _p12f1qe4 _4cvr1h6o _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpckbl _tl28idpf _axwi1tcg _1hwcidpf _sp8t1tcg _1gde1bp4 _1wm01tcg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iE2db.LoggedOutHeader), (0, $6ogO3._)({}, headerContent)),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_p12fkbql _1bsb1osq _1wafckbl"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dmP4q.LoggedOutJiraProductTourAccountCreation), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7chqp.HeroCards), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6V1n4.LogoBanner), {})
        ]
    });
};
$98430ad0795e6e5c$export$a8760ddc663c337c.displayName = "LoggedOutHeroSection";
const $98430ad0795e6e5c$var$heroStyles = null;
const $98430ad0795e6e5c$var$containerStyles = null;
const $98430ad0795e6e5c$var$formStyles = null;

});
parcelRegister("iE2db", function(module, exports) {
$parcel$export(module.exports, "LoggedOutHeader", function () { return $c37ad61dcaa246c6$export$e0bdd3a7befb091b; });
/* logged-out-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $ea4mV = parcelRequire("ea4mV");
const $c37ad61dcaa246c6$export$e0bdd3a7befb091b = ({ subHeading: subHeading, testGWP7617Experiment: testGWP7617Experiment })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const gwp7617Experiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwp7617JiraShortTermAiInfusionExperiment);
    const useGWP7617Experiment = testGWP7617Experiment || gwp7617Experiment != undefined && gwp7617Experiment.type === "enrolled" && gwp7617Experiment.value === "test";
    const mainHeading = useGWP7617Experiment ? formatMessage({
        id: "jira-product-tour.hero-header.header-text-gwp-7617",
        defaultMessage: "<strong>Focus <br></br>on <span>outcomes,</span></strong><br></br> not admin"
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: text
            }),
        span: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: text
            }),
        br: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
    }) : formatMessage({
        id: "jira-product-tour.hero-header.header-text",
        defaultMessage: "<strong>Great outcomes</strong> start with <em>Jira</em>"
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: text
            }),
        em: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("em", {
                children: text
            })
    });
    const displayedSubheading = useGWP7617Experiment ? formatMessage({
        id: "jira-product-tour.hero-header.subheading-text-gwp-7617",
        defaultMessage: "AI-powered project management that removes the work around work."
    }) : subHeading;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "logged-out-header",
        className: (0, $2jatx.default)([
            "_1e0c11p5 _p12f1y37 _6a6zv2br _jzgezwfg _1rkbko4j _zzsz1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_syaz1hlo _1wyb14no _k48p4jg8 _1bsb1osq _vwz41gnr _2h8iglyw _60qa8n31 _1fxr1ule _cq6t4jg8 _a7ooh2mm _143949fr _mnurmgnk _c9e31f51 _1vd9b3bt _h9bzgktf _1x9td439 _odmg12gs _1sphmyb0 _1sbfstnw _vr2wh2mm _15lnbx14 _vvh0mgnk _12ng1f51 _140bb3bt _18ywo7ao _1mt1yjp0 _tedggktf _h3qd1y44 _1yl3stnw _erwr1nu9 _15701ule _flz0ckbl _17q314id _fz891k4y _k5t0yjp0 _xsmr1h6o"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: mainHeading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ect4bzd7 _k48p1nn1 _1wybgktf _vwz41f4h _syaz1hlo _so7d7vkz _19q11ou6 _xsmr1h6o"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: displayedSubheading
            })
        ]
    });
};
const $c37ad61dcaa246c6$var$sectionStyles = null;
const $c37ad61dcaa246c6$var$subheadingStyles = null;
const $c37ad61dcaa246c6$var$mainHeadingStyles = null;

});

parcelRegister("dmP4q", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJiraProductTourAccountCreation", function () { return $1e25437fc90af75b$export$f1c46015a9dcb031; });

var $7VQPk = parcelRequire("7VQPk");

var $jVa6Y = parcelRequire("jVa6Y");
const $1e25437fc90af75b$export$f1c46015a9dcb031 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.default), {
        Login: null,
        Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.Social), {
            providers: {
                google: "Google"
            }
        })
    });

});





//# sourceMappingURL=index.17fcb2db.js.map
